var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 130,
    viewBox: "0 0 656 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.857,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0784 0.31475C22.9294 0.14447 21.7753 0.14447 20.6161 0.31475C21.1572 0.106543 21.7604 0.00157375 22.4259 0C23.0291 0.0262816 23.6325 0.0524058 24.2357 0.0786875C24.1482 0.138962 24.0958 0.21765 24.0784 0.31475Z",
    fill: "#E6E4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0784 0.314721C24.1833 0.314721 24.2882 0.314721 24.3931 0.314721C27.669 0.707215 30.7116 1.75628 33.5209 3.46222C33.5953 3.68349 33.7527 3.78846 33.993 3.77697C34.0674 3.99824 34.2248 4.10321 34.4651 4.09172C34.585 4.36901 34.795 4.52639 35.0946 4.56384C35.2654 4.89229 35.5276 5.10207 35.8815 5.19334C35.9865 5.19334 36.0389 5.24575 36.0389 5.35072C36.8257 6.24256 37.665 7.08184 38.5569 7.86872C38.7015 8.27616 38.9638 8.59091 39.3437 8.81297C39.3812 9.11261 39.5386 9.32255 39.8159 9.44247C39.7953 9.58033 39.8477 9.6853 39.9732 9.75722C42.9073 7.39659 46.0548 7.08184 49.4157 8.81297C50.0976 9.39006 50.7271 10.0196 51.3042 10.7015C51.5338 11.604 51.9534 11.6564 52.5632 10.8588C54.0199 10.1985 55.4888 9.569 56.9697 8.97034C57.0747 8.97034 57.1271 8.91794 57.1271 8.81297C58.4909 8.44581 59.8549 8.07866 61.2189 7.71134C61.2713 7.71134 61.3238 7.71134 61.3762 7.71134C62.9767 7.28014 64.6029 6.96539 66.2549 6.76709C66.4122 6.76709 66.5696 6.76709 66.727 6.76709C67.8764 6.62766 69.0305 6.52269 70.1892 6.45234C72.2825 6.2775 74.3808 6.25122 76.4842 6.37366C78.5358 6.58533 80.5816 6.82139 82.6218 7.08184C83.6368 7.40981 84.686 7.672 85.7693 7.86872C85.8217 7.86872 85.8743 7.86872 85.9267 7.86872C90.727 8.94375 95.2384 10.7273 99.461 13.2195C99.7529 13.4607 100.041 13.7231 100.327 14.0063C101.108 12.9368 101.973 11.94 102.923 11.0162C103.466 10.7177 103.99 10.3768 104.497 9.99328C105.078 9.75486 105.655 9.51879 106.228 9.28509C106.28 9.28509 106.333 9.28509 106.385 9.28509C109.121 8.69698 111.587 9.27392 113.782 11.0162C114.097 11.4359 114.464 11.8031 114.884 12.1178C115.481 13.05 115.953 14.0466 116.3 15.108C116.3 15.1604 116.3 15.2129 116.3 15.2653C116.812 17.7799 116.497 20.1931 115.356 22.5046C115.135 22.579 115.03 22.7364 115.041 22.9767C114.311 23.7595 113.577 24.5464 112.838 25.3373C112.361 25.5759 111.941 25.8907 111.579 26.2816C111.421 26.3866 111.264 26.4914 111.107 26.5963C110.95 26.5916 110.845 26.6703 110.792 26.8324C112.094 29.1922 113.038 31.6839 113.625 34.3077C113.625 34.3601 113.625 34.4127 113.625 34.4651C114.144 36.6907 114.512 38.9463 114.726 41.2322C114.726 41.2846 114.726 41.3372 114.726 41.3896C114.971 46.8939 115.128 52.402 115.198 57.9139C115.198 57.9663 115.198 58.0189 115.198 58.0713C115.3 58.4959 115.431 58.9156 115.592 59.3303C115.697 59.4487 115.829 59.5012 115.985 59.4877C116.356 60.0151 116.828 60.4348 117.402 60.7467C117.507 60.7467 117.559 60.7991 117.559 60.9041C118.608 62.0581 119.71 63.1597 120.864 64.2089C121.221 64.8284 121.693 65.3529 122.28 65.7827C122.478 66.2433 122.793 66.6106 123.225 66.8843C123.316 67.2382 123.526 67.5004 123.854 67.6712C124.162 68.1893 124.529 68.6614 124.956 69.0876C124.993 69.3872 125.151 69.5971 125.428 69.7171C125.77 70.402 126.19 71.0315 126.687 71.6056C127.09 72.4121 127.405 73.2514 127.631 74.1236C127.631 74.2285 127.631 74.3333 127.631 74.4383C127.642 74.6679 127.589 74.8777 127.474 75.0678C127.474 75.1202 127.474 75.1728 127.474 75.2252C127.265 75.5354 127.056 75.8501 126.844 76.1694C127.791 77.5907 128.525 79.112 129.047 80.7333C129.047 80.7857 129.047 80.8383 129.047 80.8907C129.502 82.1184 129.607 83.3774 129.362 84.6677C129.362 84.7201 129.362 84.7727 129.362 84.8251C129.31 85.0348 129.257 85.2448 129.205 85.4546C129.205 85.507 129.205 85.5595 129.205 85.6119C129.152 85.7169 129.1 85.8217 129.047 85.9267C129.047 85.9791 129.047 86.0316 129.047 86.0841C128.942 86.2938 128.838 86.5038 128.733 86.7136C128.733 86.766 128.733 86.8185 128.733 86.8709C128.471 87.2894 128.209 87.709 127.946 88.1299C127.946 88.2349 127.893 88.2873 127.788 88.2873C127.489 88.3248 127.279 88.4821 127.159 88.7594C126.591 88.9488 126.014 89.1061 125.428 89.2316C125.323 89.2316 125.218 89.2316 125.113 89.2316C125.008 89.2316 124.903 89.2316 124.798 89.2316C124.693 89.2316 124.589 89.2316 124.484 89.2316C124.28 89.1943 124.123 89.2467 124.011 89.3889C123.374 89.4055 122.745 89.353 122.123 89.2316C122.144 89.0937 122.091 88.9887 121.966 88.9168C120.419 88.3279 119.002 87.541 117.716 86.5562C117.329 86.0897 116.909 85.6439 116.457 85.2185C115.975 85.0902 115.608 85.2213 115.356 85.6119C115.356 85.6643 115.356 85.7169 115.356 85.7693C115.351 86.4569 115.403 87.1388 115.513 87.8152C115.513 87.9726 115.513 88.1299 115.513 88.2873C115.664 90.4381 115.821 92.589 115.985 94.7397C115.985 94.8446 115.985 94.9495 115.985 95.0544C116.105 96.2059 116.21 97.36 116.3 98.5167C116.3 98.6216 116.3 98.7265 116.3 98.8314C116.382 99.4579 116.434 100.087 116.457 100.72C116.457 100.772 116.457 100.825 116.457 100.877C116.51 101.402 116.562 101.927 116.615 102.451C116.615 102.556 116.615 102.661 116.615 102.766C116.825 103.5 116.825 104.235 116.615 104.969C116.51 104.969 116.457 105.021 116.457 105.126C114.889 106.147 113.21 106.96 111.421 107.566C110.808 108.663 110.179 109.738 109.533 110.792C109.256 110.912 109.098 111.122 109.061 111.421C108.732 111.592 108.523 111.854 108.431 112.208C107.847 112.635 107.375 113.159 107.015 113.782C106.858 113.834 106.753 113.939 106.7 114.097C106.7 114.202 106.648 114.254 106.543 114.254C106.28 114.412 106.071 114.621 105.913 114.884C105.913 114.989 105.861 115.041 105.756 115.041C105.471 115.264 105.366 115.579 105.441 115.985C105.441 116.09 105.441 116.195 105.441 116.3C105.486 117.206 105.434 118.098 105.284 118.975C105.284 119.028 105.284 119.08 105.284 119.133C105.152 119.187 105.099 119.291 105.126 119.448C104.824 119.494 104.561 119.625 104.34 119.841C105.516 121.685 105.569 123.548 104.497 125.428C104.392 125.638 104.235 125.795 104.025 125.9C103.725 125.937 103.515 126.095 103.395 126.372C100.9 127.386 98.3823 127.413 95.8413 126.451C95.2273 126.117 94.5978 125.829 93.9528 125.585C93.8784 125.364 93.721 125.259 93.4807 125.27C93.4063 125.049 93.2489 124.944 93.0086 124.956C92.7349 124.524 92.3676 124.209 91.907 124.011C91.6446 123.644 91.3299 123.33 90.9627 123.067C90.8053 123.015 90.7004 122.91 90.648 122.752C90.5606 122.402 90.3507 122.139 90.0185 121.966C82.4704 124.25 74.7591 125.142 66.8844 124.641C66.727 124.641 66.5696 124.641 66.4122 124.641C60.5058 124.304 54.7353 123.254 49.101 121.493C49.0486 121.493 48.996 121.493 48.9436 121.493C48.3508 121.269 47.7474 121.06 47.1338 120.864C46.8754 120.939 46.6917 121.097 46.583 121.336C46.583 121.388 46.583 121.441 46.583 121.493C46.478 121.546 46.3732 121.598 46.2682 121.651C45.8608 121.795 45.546 122.058 45.324 122.438C45.0243 122.475 44.8144 122.632 44.6945 122.91C44.1903 123.049 43.7705 123.311 43.4355 123.697C41.2636 124.843 38.9555 125.289 36.511 125.034C34.9102 124.759 33.5988 123.998 32.5766 122.752C32.0505 121.75 31.8931 120.701 32.1045 119.605C32.1045 119.553 32.1045 119.5 32.1045 119.448C32.1569 119.343 32.2095 119.238 32.2619 119.133C32.2619 119.08 32.2619 119.028 32.2619 118.975C33.2593 117.217 34.6494 115.854 36.4323 114.884C36.3506 114.407 36.0622 114.093 35.5667 113.939C35.5143 113.782 35.4094 113.677 35.252 113.625C34.5717 112.735 33.8372 111.895 33.0487 111.107C33.0113 110.807 32.8539 110.597 32.5766 110.477C32.3742 110.065 32.1119 109.698 31.7897 109.376C31.8012 109.135 31.6963 108.978 31.475 108.903C31.4498 108.643 31.345 108.433 31.1602 108.274C31.1602 108.169 31.1078 108.117 31.0029 108.117C30.9118 107.671 30.702 107.304 30.3734 107.015C29.5904 106.419 28.6987 105.999 27.698 105.756C26.8038 105.204 25.8595 104.732 24.8652 104.34C24.4554 104.009 24.062 103.642 23.6849 103.238C23.5641 102.542 23.5902 101.86 23.7636 101.192C23.7636 101.14 23.7636 101.087 23.7636 101.035C23.816 100.72 23.8686 100.405 23.921 100.09C23.921 100.038 23.921 99.9855 23.921 99.933C24.0271 98.9797 24.1844 98.0354 24.3931 97.1003C24.3931 97.0479 24.3931 96.9953 24.3931 96.9429C24.4781 96.4134 24.5829 95.8888 24.7079 95.3692C24.7079 95.3168 24.7079 95.2642 24.7079 95.2118C24.8128 94.4773 24.9177 93.743 25.0226 93.0086C25.0226 92.9561 25.0226 92.9036 25.0226 92.8512C25.1002 92.4883 25.1526 92.1211 25.18 91.7496C25.18 91.6971 25.18 91.6446 25.18 91.5922C25.3144 90.435 25.4718 89.281 25.6521 88.1299C25.6521 88.0775 25.6521 88.025 25.6521 87.9726C25.976 85.4948 26.3433 83.0292 26.7537 80.5759C26.7537 80.5235 26.7537 80.471 26.7537 80.4186C26.8825 79.4642 27.0399 78.52 27.2259 77.5858C27.2259 77.4808 27.2259 77.376 27.2259 77.2711C27.7731 74.6097 28.2452 71.9343 28.6422 69.2449C28.6422 69.1925 28.6422 69.14 28.6422 69.0876C28.7071 68.6984 28.5497 68.4886 28.1701 68.4581C28.1701 68.3531 28.1177 68.3007 28.0127 68.3007C27.4822 67.7702 26.9053 67.298 26.2816 66.8843C26.0079 66.4526 25.6406 66.1379 25.18 65.9401C24.9063 65.5084 24.539 65.1936 24.0784 64.9958C23.5538 64.3663 22.9768 63.7892 22.3473 63.2647C22.2423 62.9499 22.1375 62.6352 22.0325 62.3204C22.0325 62.268 22.0325 62.2155 22.0325 62.1631C22.0325 61.6909 22.0325 61.2188 22.0325 60.7467C22.0325 60.5369 22.0325 60.327 22.0325 60.1172C22.06 59.4812 22.0863 58.8517 22.1112 58.2287C21.7669 57.746 21.4258 57.2739 21.0883 56.8123C20.0784 55.0022 19.2389 53.1137 18.5703 51.1468C18.5703 51.0944 18.5703 51.0418 18.5703 50.9894C17.8787 48.6521 17.7738 46.2915 18.2555 43.9076C18.2555 43.8552 18.2555 43.8026 18.2555 43.7502C18.8822 41.6809 20.2461 40.3956 22.3473 39.8945C22.1438 39.2592 22.0127 38.6034 21.9538 37.9273C21.2503 37.3532 20.4896 36.8811 19.6719 36.511C18.6006 35.7049 17.4466 35.0228 16.2096 34.4651C14.9278 33.5537 13.5638 32.7668 12.1179 32.1045C11.8289 31.7759 11.4618 31.5661 11.0163 31.475C9.73444 30.5636 8.37047 29.7767 6.92451 29.1143C6.63557 28.7857 6.26841 28.576 5.82288 28.4848C5.53394 28.1562 5.16679 27.9465 4.72126 27.8553C3.34906 26.9983 1.95892 26.1588 0.550825 25.3373C0.259367 23.5049 0.285601 21.6689 0.629513 19.8292C0.629513 19.7768 0.629513 19.7242 0.629513 19.6718C1.27149 15.4007 2.89769 11.5713 5.50813 8.18347C6.39557 7.24331 7.28726 6.29906 8.18351 5.35072C8.95197 4.94013 9.63388 4.41544 10.2294 3.77697C11.5452 3.01417 12.9092 2.33211 14.3211 1.7311C14.4261 1.7311 14.4785 1.67869 14.4785 1.57372C16.4235 0.93289 18.417 0.513171 20.4588 0.314721C20.5112 0.314721 20.5637 0.314721 20.6161 0.314721C21.7754 0.144442 22.9294 0.144442 24.0784 0.314721ZM39.5011 21.5603C39.7857 21.5589 40.048 21.6376 40.288 21.7964C36.5494 26.8374 34.1626 32.4768 33.1274 38.7142C32.5961 41.4905 32.124 44.2706 31.7111 47.0551C30.5312 44.8787 28.9575 43.0428 26.9898 41.5469C26.7605 39.9877 26.472 38.4402 26.1242 36.9044C30.735 31.9018 35.1939 26.7871 39.5011 21.5603Z",
    fill: "#020201"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4587 0.314753C18.4169 0.513203 16.4235 0.932922 14.4785 1.57375C16.3832 0.651063 18.3765 0.231344 20.4587 0.314753Z",
    fill: "#EAE9E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5209 3.46225C30.7116 1.7563 27.669 0.707243 24.3931 0.31475C24.3725 0.19845 24.3988 0.0934807 24.4718 0C27.4021 0.452768 30.2088 1.4233 32.8914 2.91144C33.1421 3.06078 33.3518 3.24428 33.5209 3.46225Z",
    fill: "#EEEDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3211 1.73111C12.9092 2.33212 11.5452 3.01418 10.2294 3.77698C11.4087 2.84532 12.7203 2.11085 14.1637 1.57373C14.2593 1.59324 14.3117 1.64565 14.3211 1.73111Z",
    fill: "#EDECE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6719 2.20327C27.5875 1.5851 33.8562 4.47025 38.4782 10.8589C39.7603 12.7918 40.5996 14.89 40.9962 17.1539C37.2126 21.5143 33.488 25.9208 29.8226 30.3734C28.9162 29.6449 27.8933 29.1465 26.7537 28.8783C24.5763 28.4904 22.4255 28.5952 20.3014 29.1931C19.2086 29.6735 18.238 30.3292 17.3899 31.1603C17.1383 31.6132 16.8497 32.0327 16.5244 32.4193C11.7849 29.5253 6.95866 26.7975 2.04588 24.2358C1.9487 17.5366 4.25684 11.8448 8.97038 7.16058C12.0469 4.44193 15.6141 2.78949 19.6719 2.20327Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5209 3.46228C33.7612 3.45079 33.9186 3.55576 33.993 3.77703C33.7527 3.78851 33.5953 3.68354 33.5209 3.46228Z",
    fill: "#F1F1EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.816,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.993 3.77697C34.2333 3.76548 34.3907 3.87045 34.4651 4.09172C34.2248 4.10321 34.0674 3.99824 33.993 3.77697Z",
    fill: "#F0F1EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4651 4.09174C34.7648 4.12919 34.9747 4.28657 35.0946 4.56386C34.795 4.52641 34.585 4.36903 34.4651 4.09174Z",
    fill: "#F1EFEC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2294 3.77698C9.63387 4.41545 8.95196 4.94014 8.1835 5.35073C8.36055 5.09436 8.57049 4.8583 8.813 4.64254C9.24138 4.27145 9.7135 3.98298 10.2294 3.77698Z",
    fill: "#E2DEDC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0946 4.56387C35.4485 4.65515 35.7107 4.86493 35.8815 5.19337C35.5275 5.1021 35.2654 4.89231 35.0946 4.56387Z",
    fill: "#ECEAE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0388 5.35074C37.0355 6.03264 37.8749 6.87208 38.5568 7.86874C37.665 7.08186 36.8257 6.24258 36.0388 5.35074Z",
    fill: "#F1EFEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1892 6.45237C69.0305 6.52272 67.8764 6.62769 66.727 6.76712C66.7095 6.67002 66.6571 6.59133 66.5696 6.53106C66.7688 6.48243 66.9525 6.40374 67.1204 6.295C68.1559 6.28178 69.1789 6.33418 70.1892 6.45237Z",
    fill: "#E5E4E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6323 19.5145C32.1163 15.2085 30.3852 12.1921 26.439 10.4654C23.7921 9.70892 21.6675 10.4171 20.0653 12.59C19.0326 14.879 19.7408 16.3478 22.1899 16.9965C22.0435 20.2112 20.3649 21.6537 17.1539 21.3243C13.7547 20.0735 12.076 17.6342 12.1179 14.0064C13.5062 9.19336 16.7061 6.67536 21.7177 6.45236C26.2728 6.61792 29.499 8.76876 31.3963 12.9047C32.2192 15.1074 32.2979 17.3106 31.6323 19.5145Z",
    fill: "#165EA1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.668,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18349 5.35074C7.28724 6.29908 6.39555 7.24333 5.50812 8.18349C6.18278 7.0367 7.07463 6.09245 8.18349 5.35074Z",
    fill: "#F7F7F3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.924,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2548 6.76711C64.6029 6.9654 62.9767 7.28015 61.3762 7.71136C61.3951 7.54045 61.5001 7.43548 61.691 7.39661C63.2161 6.95784 64.7373 6.74791 66.2548 6.76711Z",
    fill: "#EAE7E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.596,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6218 7.08188C83.4707 7.14137 84.31 7.27262 85.1398 7.47532C85.4447 7.49452 85.6544 7.62561 85.7693 7.86875C84.686 7.67203 83.6367 7.40985 82.6218 7.08188Z",
    fill: "#E9E7E4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.376,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4157 8.81299C46.0548 7.08187 42.9073 7.39662 39.9732 9.75724C39.8476 9.68532 39.7952 9.58035 39.8159 9.44249C40.7318 8.90568 41.676 8.40728 42.6486 7.94743C44.4321 7.21296 46.2158 7.21296 47.9994 7.94743C48.5787 8.08466 49.0508 8.37328 49.4157 8.81299Z",
    fill: "#F0EEEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.939,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2189 7.71136C59.8549 8.07867 58.4909 8.44583 57.1271 8.81298C58.32 8.25116 59.579 7.83144 60.9041 7.55399C61.0483 7.56075 61.1532 7.61316 61.2189 7.71136Z",
    fill: "#F0EEEC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.117 22.8194C108.325 22.8461 108.508 22.7937 108.667 22.662C109.636 21.1745 110.055 19.5483 109.926 17.7834C109.769 17.521 109.612 17.2588 109.454 16.9965C109.341 17.0821 109.263 17.1871 109.218 17.3112C108.309 16.8758 107.417 16.9021 106.543 17.3899C105.378 18.1984 104.696 19.3 104.497 20.6948C104.504 21.0044 104.582 21.293 104.733 21.5604C110.287 27.9353 113.12 35.3843 113.231 43.9076C113.362 47.3185 113.336 50.7284 113.153 54.137C107.575 56.5059 101.962 58.7879 96.3134 60.9828C85.822 64.8778 75.3566 68.8385 64.9171 72.8646C54.0037 66.754 43.4596 60.0919 33.2848 52.878C33.4127 47.3363 34.1733 41.8806 35.5667 36.511C36.9126 44.858 41.7912 48.5039 50.2026 47.4485C52.6721 46.8041 54.7967 45.5714 56.5763 43.7502C56.2738 46.8582 57.6378 48.7991 60.668 49.5731C60.2459 54.9193 62.6853 57.0438 67.986 55.9468C69.4549 55.4219 70.3729 54.399 70.74 52.878C70.9522 51.8909 71.0834 50.8943 71.1335 49.8878C74.4717 49.2456 75.8094 47.2521 75.1465 43.9076C74.741 42.6623 73.9802 41.6918 72.8646 40.9962C72.0621 40.5425 71.2227 40.1751 70.3466 39.8945C68.7816 37.4485 66.5784 36.6092 63.7368 37.3765C62.6319 37.8531 61.7139 38.5613 60.9828 39.5011C60.4773 39.6934 59.9789 39.7458 59.4877 39.6585C61.7286 34.3575 61.1778 29.3739 57.8353 24.7079C54.9273 21.7102 51.3864 20.5299 47.2125 21.1669C44.6898 21.5626 42.5389 22.6642 40.7601 24.4718C40.6551 24.5768 40.5503 24.5768 40.4453 24.4718C48.0554 13.6756 58.5208 8.19357 71.8416 8.02612C79.6849 8.08388 87.2126 9.6315 94.4249 12.6687C96.7199 13.7347 98.8706 15.02 100.877 16.5244C102.066 13.9453 103.955 12.0831 106.543 10.9376C109.318 10.4753 111.652 11.2885 113.546 13.3769C115.694 17.3326 115.09 20.821 111.736 23.8423C111.117 24.2962 110.461 24.6896 109.769 25.0226C109.106 24.3829 108.556 23.6484 108.117 22.8194Z",
    fill: "#5DB7B2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5569 7.86874C38.9368 8.0908 39.1991 8.40555 39.3437 8.81299C38.9638 8.59094 38.7015 8.27619 38.5569 7.86874Z",
    fill: "#EDEBEA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.502,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9267 7.86874C85.9923 7.77054 86.0973 7.71813 86.2414 7.71136C91.0091 8.75633 95.4156 10.5924 99.4609 13.2195C95.2384 10.7273 90.7269 8.94377 85.9267 7.86874Z",
    fill: "#ECEAE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.897,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.782 11.0162C111.587 9.27395 109.121 8.69701 106.385 9.28512C106.404 9.11421 106.509 9.00924 106.7 8.97037C109.03 8.56025 111.181 9.0061 113.153 10.3081C113.419 10.5137 113.629 10.7498 113.782 11.0162Z",
    fill: "#ECEBE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3437 8.81299C39.621 8.93291 39.7784 9.14285 39.8158 9.44249C39.5385 9.32257 39.3812 9.11263 39.3437 8.81299Z",
    fill: "#EDE9E8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1207 18.2555C42.911 18.2555 42.806 18.1505 42.806 17.9407C43.012 16.6374 42.8283 15.3784 42.2552 14.1637C41.931 13.358 41.5638 12.5711 41.1536 11.8031C41.0486 11.5933 41.0486 11.3834 41.1536 11.1736C42.7555 9.74843 44.6179 9.25018 46.7404 9.67855C48.2436 10.1861 49.2665 11.1566 49.8092 12.59C48.5311 13.5004 47.2984 14.4709 46.1109 15.5014C45.5731 15.3922 45.0484 15.1824 44.5371 14.8719C44.065 14.767 43.5929 14.767 43.1207 14.8719C42.949 15.1967 42.9228 15.5378 43.0421 15.8949C43.4737 16.2549 43.9197 16.596 44.3797 16.9178C43.9235 17.3473 43.5038 17.7931 43.1207 18.2555Z",
    fill: "#61B8B3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.228 9.28513C105.655 9.51883 105.078 9.75489 104.497 9.99331C103.99 10.3768 103.466 10.7177 102.923 11.0162C103.819 9.96561 104.921 9.38852 106.228 9.28513Z",
    fill: "#E9E7E2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6324 19.5145C30.3343 23.828 27.4492 26.3197 22.9767 26.9898C20.4754 27.2433 18.2198 26.6401 16.2096 25.18C16.9121 25.1954 17.5941 25.3265 18.2555 25.5734C20.9167 26.0325 23.1986 25.3243 25.1013 23.4489C26.3229 21.8226 26.6376 20.0389 26.0456 18.0981C25.6181 17.25 24.9362 16.7779 23.9997 16.6817C23.4103 16.8372 22.8071 16.9422 22.1899 16.9965C19.7408 16.3478 19.0326 14.879 20.0653 12.59C21.6675 10.4171 23.7921 9.70894 26.439 10.4654C30.3852 12.1922 32.1163 15.2086 31.6324 19.5145Z",
    fill: "#CD4A34"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4157 8.81299C50.3076 9.18014 50.9371 9.80964 51.3042 10.7015C50.7271 10.0196 50.0976 9.39008 49.4157 8.81299Z",
    fill: "#E9E5E2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9697 8.97036C55.4888 9.56902 54.0199 10.1985 52.5632 10.8589C53.8469 9.99409 55.2372 9.31218 56.7337 8.81299C56.8541 8.824 56.9327 8.87641 56.9697 8.97036Z",
    fill: "#F1F1ED"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.376,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.782 11.0162C114.307 11.226 114.674 11.5933 114.884 12.1179C114.464 11.8031 114.097 11.436 113.782 11.0162Z",
    fill: "#F9F8F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3042 10.7015C51.495 10.8164 51.6523 10.9738 51.7764 11.1736C52.0242 11.0232 52.2866 10.9182 52.5632 10.8589C51.9534 11.6565 51.5338 11.6041 51.3042 10.7015Z",
    fill: "#DFDDDA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.884 12.1179C115.816 12.9321 116.288 13.9288 116.3 15.108C115.953 14.0466 115.481 13.05 114.884 12.1179Z",
    fill: "#EDEBE7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.923 11.0162C101.973 11.94 101.108 12.9368 100.326 14.0064C100.041 13.7231 99.7529 13.4607 99.4609 13.2195C99.8039 13.273 100.092 13.4304 100.326 13.6916C101.012 12.6131 101.877 11.7213 102.923 11.0162Z",
    fill: "#EFECEA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50811 8.1835C2.89767 11.5713 1.27147 15.4007 0.629486 19.6719C0.693223 17.6827 1.13911 15.7417 1.96717 13.849C2.79496 11.7172 3.97528 9.8287 5.50811 8.1835Z",
    fill: "#EDEBE9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1179 14.0064C12.076 17.6342 13.7547 20.0735 17.1539 21.3243C20.365 21.6537 22.0435 20.2112 22.1899 16.9965C22.8071 16.9422 23.4103 16.8372 23.9997 16.6818C24.9362 16.7779 25.6181 17.25 26.0456 18.0981C26.6376 20.0389 26.3229 21.8226 25.1013 23.4489C23.1986 25.3243 20.9167 26.0325 18.2555 25.5734C17.5941 25.3265 16.9122 25.1954 16.2096 25.18C16.1352 24.9587 15.9778 24.8538 15.7375 24.8652C14.7929 24.2616 14.0323 23.4747 13.4556 22.5046C11.8241 20.0074 11.2995 17.2796 11.8818 14.3211C11.9256 14.177 12.0043 14.0722 12.1179 14.0064Z",
    fill: "#FAB344"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.117 22.8194C107.402 22.0248 106.773 21.1592 106.228 20.2227C106.884 19.1837 107.776 18.3968 108.903 17.8621C109.112 17.7336 109.216 17.55 109.218 17.3112C109.263 17.1871 109.341 17.0821 109.454 16.9965C109.612 17.2588 109.769 17.521 109.926 17.7834C110.055 19.5483 109.636 21.1745 108.667 22.662C108.508 22.7937 108.325 22.8461 108.117 22.8194Z",
    fill: "#44828F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.806 17.9407C42.806 18.1505 42.9109 18.2555 43.1207 18.2555C42.6034 18.9572 42.0526 19.6391 41.4683 20.3014C41.2159 20.212 41.111 20.0546 41.1535 19.8292C41.6831 19.1694 42.2339 18.5399 42.806 17.9407Z",
    fill: "#45828E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.376,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.3 15.2654C116.555 15.4368 116.686 15.6991 116.693 16.0523C116.932 17.8921 116.722 19.6757 116.064 21.403C115.903 21.8341 115.666 22.2012 115.356 22.5046C116.497 20.1931 116.812 17.7799 116.3 15.2654Z",
    fill: "#EFEFEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2415 21.5604C91.5765 21.121 95.8517 23.0095 99.0675 27.2259C102.446 33.1526 102.289 38.9755 98.5954 44.6945C94.3927 49.2946 89.278 50.7371 83.2513 49.0223C78.0521 46.9697 75.0883 43.1664 74.3597 37.6126C73.916 31.7611 76.0406 27.1185 80.7333 23.6849C82.4609 22.6466 84.2969 21.9384 86.2415 21.5604Z",
    fill: "#020202"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.533,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.356 22.5046C115.367 22.7449 115.262 22.9023 115.041 22.9767C115.03 22.7364 115.135 22.579 115.356 22.5046Z",
    fill: "#EFF0EC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5272 22.8194C54.8982 22.5839 58.7278 26.151 59.0156 33.5209C58.874 38.8672 56.4084 42.7229 51.619 45.0879C47.9037 46.5344 44.3889 46.1672 41.0749 43.9863C37.9329 41.0133 36.7001 37.3674 37.3765 33.0487C38.6922 27.5627 42.0758 24.1528 47.5272 22.8194Z",
    fill: "#FEFEFE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0841 23.2915C91.9049 22.7515 96.1277 25.0598 98.7528 30.216C100.511 35.0882 99.9339 39.652 97.0216 43.9076C93.863 47.1988 90.0073 48.4839 85.4546 47.7633C79.3532 46.2228 76.2057 42.2884 76.0121 35.9602C76.1814 31.477 78.0175 27.8574 81.5202 25.1013C82.9518 24.2315 84.473 23.6283 86.0841 23.2915Z",
    fill: "#FEFEFE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.502,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.041 22.9767C114.524 23.9655 113.79 24.7524 112.838 25.3374C113.577 24.5464 114.311 23.7595 115.041 22.9767Z",
    fill: "#EFEDE8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7375 24.8652C15.9778 24.8537 16.1352 24.9587 16.2096 25.18C15.9693 25.1915 15.8119 25.0865 15.7375 24.8652Z",
    fill: "#8C361E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.838 25.3374C112.532 25.8049 112.112 26.1197 111.579 26.2816C111.941 25.8907 112.361 25.576 112.838 25.3374Z",
    fill: "#ECEAE8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6295 19.8292C0.285588 21.6689 0.259354 23.5049 0.550812 25.3373C1.95891 26.1588 3.34905 26.9983 4.72125 27.8553C3.22419 27.1723 1.78159 26.3855 0.393437 25.4947C0.217712 24.9042 0.0865719 24.301 0 23.6849C0.121604 22.7204 0.200291 21.7498 0.236062 20.7735C0.236424 20.372 0.367565 20.0573 0.6295 19.8292Z",
    fill: "#F1F0EC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72125 27.8553C5.16678 27.9465 5.53394 28.1562 5.82288 28.4848C5.37735 28.3937 5.01019 28.1839 4.72125 27.8553Z",
    fill: "#EBEAE6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82288 28.4849C6.2684 28.576 6.63556 28.7858 6.9245 29.1144C6.47897 29.0232 6.11182 28.8135 5.82288 28.4849Z",
    fill: "#ECEBE6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.845,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9245 29.1143C8.37046 29.7767 9.73443 30.5636 11.0162 31.475C9.57029 30.8126 8.20632 30.0257 6.9245 29.1143Z",
    fill: "#F0EDEB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.314,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.107 26.5964C111.089 26.6935 111.037 26.7721 110.949 26.8324C112.262 29.066 113.206 31.453 113.782 33.993C113.775 34.1371 113.723 34.2421 113.625 34.3077C113.038 31.684 112.094 29.1923 110.792 26.8324C110.845 26.6703 110.95 26.5916 111.107 26.5964Z",
    fill: "#F1F0EB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7206 29.9012C55.677 30.1046 57.1458 31.7044 57.1271 34.7012C57.179 36.646 56.497 38.2722 55.0812 39.5798C52.0865 40.9806 50.0668 40.115 49.0223 36.9831C48.3752 34.2931 49.1359 32.116 51.3042 30.4521C51.7875 30.2481 52.2596 30.0646 52.7206 29.9012Z",
    fill: "#020101"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8194 30.5307C23.3439 30.5307 23.8686 30.5307 24.3931 30.5307C24.0376 33.8233 24.2474 37.0758 25.0226 40.288C24.7079 40.2356 24.3931 40.183 24.0784 40.1306C23.7978 36.9959 23.1157 33.9533 22.0325 31.0029C22.2602 30.777 22.5226 30.6196 22.8194 30.5307Z",
    fill: "#F4C499"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2816 30.8455C27.101 30.9404 27.7829 31.2814 28.3275 31.8684C27.6737 32.7321 26.913 33.4927 26.0455 34.1504C25.8962 33.0237 25.9749 31.9221 26.2816 30.8455Z",
    fill: "#F6C49A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5661 30.8455C86.983 30.7212 88.7667 32.3736 88.9168 35.8028C89.0001 37.9968 88.1606 39.7279 86.3988 40.9962C83.601 42.1286 81.5814 41.3156 80.3399 38.5569C79.4945 35.8332 80.0977 33.4987 82.1497 31.5537C82.5941 31.2265 83.0662 30.9904 83.5661 30.8455Z",
    fill: "#010101"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9866 31.475C20.2422 31.4529 20.4257 31.5579 20.5374 31.7897C21.0067 32.9834 21.2952 34.1898 21.403 35.4093C20.3267 34.7402 19.2775 34.032 18.2555 33.2848C18.7586 32.5983 19.3356 31.9951 19.9866 31.475Z",
    fill: "#F7C69B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0162 31.475C11.4618 31.5661 11.8289 31.7759 12.1179 32.1045C11.6723 32.0134 11.3052 31.8036 11.0162 31.475Z",
    fill: "#F0EEEB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1179 32.1045C13.5638 32.7669 14.9278 33.5538 16.2096 34.4651C14.7416 33.8367 13.3776 33.0498 12.1179 32.1045Z",
    fill: "#F0EEEA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8222 33.2061C54.8066 33.0111 55.3837 33.4046 55.5534 34.3864C55.3639 35.3474 54.7868 35.7145 53.8222 35.488C52.9937 34.7131 52.9937 33.9524 53.8222 33.2061Z",
    fill: "#FAF9F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4546 34.1504C86.6583 34.1211 87.1566 34.6982 86.9496 35.8815C86.5993 36.5678 86.0485 36.8039 85.2972 36.5897C84.6587 36.2833 84.4227 35.7848 84.589 35.0946C84.7497 34.6461 85.0382 34.3313 85.4546 34.1504Z",
    fill: "#FAF9F8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.625 34.4651C113.85 34.5251 113.981 34.6825 114.018 34.9372C114.422 36.7545 114.711 38.5905 114.884 40.4454C114.883 40.7395 114.83 41.0018 114.726 41.2322C114.512 38.9464 114.144 36.6907 113.625 34.4651Z",
    fill: "#E8E7E5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2096 34.4651C17.4466 35.0229 18.6006 35.7049 19.6719 36.511C18.4349 35.9533 17.2809 35.2712 16.2096 34.4651Z",
    fill: "#EFEDEA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6719 36.511C20.4896 36.8811 21.2503 37.3533 21.9538 37.9274C22.0127 38.6034 22.1438 39.2592 22.3472 39.8945C20.2461 40.3956 18.8822 41.6809 18.2555 43.7502C18.4031 42.4563 19.0326 41.381 20.144 40.524C20.8042 40.2206 21.4337 39.8796 22.0325 39.5011C21.8916 38.9805 21.7604 38.456 21.6391 37.9274C20.9548 37.4768 20.299 37.0047 19.6719 36.511Z",
    fill: "#EFECE8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9598 41.7044C60.2412 41.6595 60.5036 41.7119 60.7467 41.8617C61.9472 43.4851 63.5733 44.3245 65.6253 44.3797C66.5488 44.2669 67.4405 44.0308 68.3007 43.6715C69.0619 43.2232 69.7177 42.6724 70.2679 42.0191C72.1972 42.3493 73.3775 43.4509 73.8088 45.324C73.6573 46.9707 72.7654 47.9413 71.1335 48.2354C69.2964 48.5629 67.6177 48.1956 66.0975 47.1338C65.809 47.1075 65.5204 47.0814 65.2319 47.0551C64.3245 47.1302 63.4589 47.3662 62.6352 47.7633C60.0793 48.2203 58.5055 47.1974 57.914 44.6945C58.1673 43.3996 58.8494 42.4028 59.9598 41.7044Z",
    fill: "#F5C59B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2555 43.9076C17.7738 46.2915 17.8787 48.6521 18.5702 50.9895C18.4133 50.9942 18.3084 50.9155 18.2555 50.7534C17.6124 48.6587 17.4812 46.5342 17.862 44.3797C17.8992 44.1249 18.0303 43.9676 18.2555 43.9076Z",
    fill: "#E2E0DF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6811 48.6288C64.8901 49.4088 64.9951 50.2481 64.9958 51.1468C64.9696 51.9861 64.9434 52.8256 64.9172 53.6648C64.8648 53.8746 64.8122 54.0846 64.7598 54.2943C63.4983 54.2989 62.659 53.6694 62.2418 52.4058C61.91 51.361 61.9362 50.3381 62.3205 49.337C63.1714 49.2473 63.9583 49.0113 64.6811 48.6288Z",
    fill: "#FEFDFD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7827 48.7862C66.958 49.1693 68.1383 49.5364 69.3236 49.8878C69.4769 51.3584 69.1359 52.696 68.3007 53.9009C67.4844 54.4226 66.6188 54.5537 65.704 54.2943C65.5866 52.4542 65.6127 50.6181 65.7827 48.7862Z",
    fill: "#FDFCFC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.726 41.3896C114.93 41.6332 115.035 41.948 115.041 42.3338C115.365 47.55 115.418 52.7434 115.198 57.914C115.128 52.4021 114.971 46.8939 114.726 41.3896Z",
    fill: "#EEEDE9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1602 50.8321C31.2765 50.8115 31.3815 50.8378 31.475 50.9108C30.6859 55.9096 29.9252 60.9193 29.1931 65.9401C29.1663 66.2887 29.0613 66.6034 28.8783 66.8843C27.1853 65.6116 25.5854 64.2215 24.0784 62.7139C25.6409 61.676 26.8737 60.3383 27.7767 58.7008C29.2089 56.2042 30.3367 53.5813 31.1602 50.8321Z",
    fill: "#FEFEFE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5046 41.547C22.9796 41.521 23.4517 41.5473 23.921 41.6257C26.578 43.181 28.6501 45.3056 30.1373 47.9993C29.5977 52.2666 27.9976 56.096 25.3374 59.4877C22.0868 55.9757 20.1457 51.8314 19.5145 47.0551C19.583 45.8147 19.819 44.6081 20.2227 43.4355C20.6854 42.4199 21.4461 41.7904 22.5046 41.547Z",
    fill: "#5BB5B0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5702 51.1469C19.2389 53.1137 20.0784 55.0022 21.0882 56.8123C19.9308 55.1527 19.0389 53.3429 18.4129 51.3829C18.4239 51.2625 18.4763 51.1838 18.5702 51.1469Z",
    fill: "#F2F1ED"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5766 54.6091C42.2722 61.4527 52.2916 67.8264 62.6352 73.7302C60.7382 74.6393 58.876 75.6097 57.0484 76.6416C50.2553 72.7315 43.6718 68.5086 37.2978 63.9729C35.449 62.6492 33.6916 61.2067 32.0258 59.6451C32.1128 57.9595 32.2965 56.2809 32.5766 54.6091Z",
    fill: "#FEFEFE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.838 56.0255C112.995 56.0255 113.153 56.0255 113.31 56.0255C113.416 57.0799 113.416 58.129 113.31 59.173C103.632 65.5075 93.3496 70.7271 82.4644 74.8318C75.1402 77.6579 67.7699 80.3594 60.3533 82.9366C59.2055 82.6736 58.1039 82.7786 57.0484 83.2513C56.6553 83.1857 56.2618 83.1332 55.8681 83.094C55.7016 81.5885 56.0426 80.2246 56.891 79.0022C58.2404 77.9467 59.683 77.0286 61.2188 76.2482C63.596 75.1645 66.009 74.1678 68.4581 73.258C81.9577 68.4786 95.3346 63.3902 108.589 57.9927C110.054 57.4096 111.471 56.7538 112.838 56.0255Z",
    fill: "#FEFEFE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0882 56.8123C21.4258 57.2739 21.7668 57.7461 22.1112 58.2287C22.0863 58.8518 22.06 59.4813 22.0325 60.1172C21.9028 59.5173 21.8241 58.8878 21.7964 58.2287C21.4757 57.797 21.2396 57.3249 21.0882 56.8123Z",
    fill: "#F2F2ED"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.198 58.0714C115.487 58.5051 115.749 58.9772 115.985 59.4877C115.829 59.5013 115.697 59.4487 115.592 59.3303C115.431 58.9157 115.3 58.4959 115.198 58.0714Z",
    fill: "#EDEBE6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.251,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.985 59.4877C116.555 59.7951 117.027 60.2146 117.402 60.7467C116.828 60.4348 116.356 60.0151 115.985 59.4877Z",
    fill: "#D9D6D2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7636 60.2746C24.4948 60.5949 24.5209 60.9096 23.8423 61.2188C23.7644 60.9083 23.7381 60.5936 23.7636 60.2746Z",
    fill: "#F3F4F5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.254 60.432C114.637 60.6287 115.004 60.8648 115.356 61.1402C118.941 64.4603 122.114 68.106 124.877 72.0777C125.099 72.4161 125.23 72.7834 125.27 73.1793C123.539 73.2755 121.966 73.8263 120.549 74.8318C118.53 76.2219 116.825 77.9269 115.435 79.9465C114.897 80.942 114.504 81.9912 114.254 83.094C111.604 80.5749 109.269 77.7947 107.251 74.7531C106.475 70.9224 107.209 67.4078 109.454 64.209C110.767 62.5521 112.367 61.2931 114.254 60.432Z",
    fill: "#FEFEFE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6324 61.5336C39.2639 67.4564 47.2638 72.8597 55.632 77.7432C54.6569 79.358 54.0798 81.1417 53.9009 83.094C53.2059 83.5005 52.7075 84.0776 52.4059 84.8251C45.8041 84.4414 39.3518 83.2087 33.0487 81.1268C31.6361 80.6172 30.2985 79.9614 29.0357 79.1596C29.7136 73.2563 30.5792 67.3809 31.6324 61.5336Z",
    fill: "#FEFEFE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.559 60.9041C117.802 60.936 118.012 61.041 118.189 61.2188C119.146 62.1749 120.038 63.1717 120.864 64.209C119.71 63.1597 118.608 62.0581 117.559 60.9041Z",
    fill: "#FAFAF4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0325 60.7467C22.0325 61.2188 22.0325 61.691 22.0325 62.1631C21.8288 61.9195 21.7239 61.6047 21.7177 61.2188C21.744 60.9041 21.7701 60.5893 21.7964 60.2746C21.8329 60.4693 21.9116 60.6266 22.0325 60.7467Z",
    fill: "#BFB3B2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.816,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0325 62.3205C22.1375 62.6352 22.2423 62.95 22.3472 63.2647C21.9566 63.0153 21.8518 62.7005 22.0325 62.3205Z",
    fill: "#F1F0EC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.878,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3472 63.2647C22.9767 63.7892 23.5538 64.3663 24.0784 64.9958C23.3439 64.5761 22.7669 63.9992 22.3472 63.2647Z",
    fill: "#F3F0EB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.172 64.6811C107.289 64.6605 107.394 64.6868 107.487 64.7598C106.395 66.4608 105.74 68.3231 105.52 70.3466C105.389 71.9274 105.442 73.5012 105.677 75.0678C106.965 77.9303 108.775 80.422 111.107 82.5431C108.648 83.4203 106.13 83.9974 103.553 84.2743C106.52 83.6684 107.596 81.911 106.779 79.0022C106.019 77.4809 104.786 76.799 103.081 76.9563C103.254 74.5875 102.179 73.2236 99.8544 72.8646C97.3145 73.0695 96.1868 74.4333 96.4708 76.9563C93.8378 76.7577 92.4214 77.9642 92.2217 80.576C92.1644 81.9003 92.689 82.9232 93.7955 83.6448C94.4933 83.9823 95.2276 84.1921 95.9987 84.2743C96.1459 84.649 96.1983 85.0424 96.1561 85.4546C88.6498 86.2042 81.1482 86.4402 73.6515 86.1628C72.3723 84.8082 70.7986 84.0214 68.9302 83.8021C67.2471 83.7609 65.5684 83.6559 63.8942 83.4874C71.9798 80.5999 80.006 77.5573 87.9726 74.3596C94.6418 71.576 101.042 68.3498 107.172 64.6811Z",
    fill: "#FEFEFE"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.864 64.209C121.452 64.6388 121.924 65.1633 122.28 65.7827C121.693 65.3529 121.221 64.8284 120.864 64.209Z",
    fill: "#EDEAE6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0784 64.9958C24.539 65.1937 24.9063 65.5084 25.18 65.9401C24.7194 65.7423 24.352 65.4275 24.0784 64.9958Z",
    fill: "#ECEAE7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.18 65.9401C25.6406 66.1379 26.0079 66.4527 26.2816 66.8843C25.821 66.6865 25.4537 66.3718 25.18 65.9401Z",
    fill: "#F0ECE9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.28 65.7827C122.712 66.0564 123.027 66.4237 123.225 66.8843C122.793 66.6107 122.478 66.2434 122.28 65.7827Z",
    fill: "#EEECE5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2816 66.8843C26.9053 67.2981 27.4822 67.7702 28.0127 68.3007C27.3396 68.0573 26.7626 67.5851 26.2816 66.8843Z",
    fill: "#F2EEEA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.225 66.8843C123.553 67.0551 123.763 67.3173 123.854 67.6712C123.526 67.5005 123.316 67.2383 123.225 66.8843Z",
    fill: "#F2F0EB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.689,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.854 67.6712C124.401 68.0075 124.768 68.4796 124.956 69.0876C124.529 68.6614 124.162 68.1893 123.854 67.6712Z",
    fill: "#F2EEEA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1701 68.4581C28.5497 68.4886 28.7071 68.6984 28.6422 69.0876C28.4867 68.8838 28.3294 68.674 28.1701 68.4581Z",
    fill: "#D6D1CF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.956 69.0876C125.233 69.2075 125.39 69.4174 125.428 69.7171C125.151 69.5972 124.993 69.3872 124.956 69.0876Z",
    fill: "#F2ECEA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.428 69.7171C126.003 70.2369 126.423 70.8664 126.687 71.6056C126.189 71.0315 125.77 70.402 125.428 69.7171Z",
    fill: "#EFEFEA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.876,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6422 69.245C28.2452 71.9343 27.773 74.6097 27.2259 77.2711C27.1253 77.1771 27.0729 77.046 27.0685 76.8776C27.5308 74.2762 28.0554 71.732 28.6422 69.245Z",
    fill: "#E8E7E4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.892,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.687 71.6056C127.103 72.1207 127.444 72.6978 127.71 73.3367C127.832 73.6337 127.806 73.896 127.631 74.1236C127.405 73.2514 127.09 72.4121 126.687 71.6056Z",
    fill: "#ECEBEA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1462 74.2809C100.116 74.097 100.876 74.4117 101.428 75.2252C101.698 76.0486 101.803 76.8879 101.743 77.7432C101.208 78.1985 100.763 78.723 100.405 79.3169C100.192 78.3066 100.245 77.3098 100.563 76.3268C100.454 75.5949 100.034 75.3588 99.3036 75.6186C99.2249 75.6973 99.1462 75.776 99.0675 75.8547C99.2557 76.9942 99.3083 78.1483 99.2249 79.3169C98.8167 78.7505 98.3445 78.2259 97.8085 77.7432C97.6785 76.9423 97.7311 76.1554 97.9659 75.3826C98.24 74.8717 98.6335 74.5046 99.1462 74.2809Z",
    fill: "#CD4934"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.878,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.631 74.4384C127.729 74.504 127.782 74.6089 127.788 74.7531C127.75 74.944 127.645 75.049 127.474 75.0679C127.589 74.8777 127.642 74.668 127.631 74.4384Z",
    fill: "#EAEAE9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.956 76.3268C121.856 77.5748 119.522 79.6731 117.953 82.6218C117.772 83.0771 117.693 83.5492 117.716 84.0382C117.138 83.5651 116.614 83.0406 116.143 82.4644C116.455 81.2878 117.006 80.2385 117.795 79.317C119.39 77.5627 121.253 76.1726 123.382 75.1465C124.132 75.1827 124.657 75.5761 124.956 76.3268Z",
    fill: "#458693"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.956 76.3268C127.014 78.9087 127.88 81.8465 127.552 85.1398C127.29 86.3458 126.582 87.159 125.428 87.5791C123.48 87.8662 121.749 87.3941 120.234 86.1628C119.319 85.535 118.48 84.8268 117.716 84.0382C117.693 83.5493 117.772 83.0771 117.953 82.6218C119.522 79.6731 121.856 77.5748 124.956 76.3268Z",
    fill: "#59B4AE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.474 75.2252C127.559 75.2347 127.612 75.2871 127.631 75.3826C127.413 75.6358 127.255 75.9243 127.159 76.2482C128.007 77.578 128.689 78.9943 129.205 80.4973C129.194 80.6177 129.141 80.6964 129.047 80.7333C128.525 79.1121 127.791 77.5907 126.844 76.1695C127.056 75.8502 127.265 75.5354 127.474 75.2252Z",
    fill: "#F2F1EC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2118 78.3727C96.5155 78.2333 97.5385 78.7054 98.2806 79.7891C98.3567 79.9383 98.3828 80.0957 98.3593 80.2612C97.3381 80.1555 96.3415 79.9718 95.3692 79.7104C94.6983 80.127 94.5934 80.6517 95.0545 81.2842C95.8942 81.2067 96.7335 81.0756 97.5725 80.8907C97.8348 80.9431 98.097 80.9957 98.3593 81.0481C97.7404 81.7448 97.0059 82.2956 96.1561 82.7005C94.2666 82.6464 93.4536 81.6759 93.7168 79.7891C94.0112 79.0819 94.5096 78.6097 95.2118 78.3727Z",
    fill: "#CC4933"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.923 78.3727C104.585 78.1999 105.477 78.9344 105.599 80.576C105.629 81.6943 105.105 82.4024 104.025 82.7005C103.044 82.8807 102.231 82.5922 101.586 81.835C101.34 81.5647 101.209 81.25 101.192 80.8907C102.093 80.987 102.985 81.1444 103.867 81.3628C104.663 81.1601 104.82 80.7141 104.34 80.0251C103.518 79.9738 102.705 80.0525 101.9 80.2612C101.603 80.2146 101.315 80.1359 101.035 80.0251C101.5 79.2699 102.13 78.7191 102.923 78.3727Z",
    fill: "#CC4933"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.816,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2259 77.5858C27.0399 78.52 26.8825 79.4643 26.7537 80.4186C26.6511 80.2692 26.5986 80.0857 26.5964 79.8678C26.719 79.0534 26.8502 78.2402 26.9898 77.4285C27.0501 77.516 27.1288 77.5684 27.2259 77.5858Z",
    fill: "#E3E0DD"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6183 79.9465C100.058 80.02 100.268 80.2822 100.248 80.7333C99.9855 80.7333 99.7233 80.7333 99.4609 80.7333C99.4812 80.4633 99.5336 80.2009 99.6183 79.9465Z",
    fill: "#CC4B36"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4849 80.8907C31.348 82.3091 34.3381 83.437 37.4552 84.2743C41.6178 85.2217 45.8145 85.9823 50.0452 86.5562C48.7055 87.9753 47.6826 89.6016 46.9764 91.4348C41.5179 90.8903 36.1934 89.6576 31.0029 87.7365C29.9108 87.2153 28.8353 86.6645 27.7767 86.0841C27.909 84.3443 28.1451 82.6132 28.4849 80.8907Z",
    fill: "#165DA1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9888 81.5202C99.1696 81.566 99.2746 81.6971 99.3036 81.9136C99.1827 82.786 99.0253 83.6515 98.8314 84.5103C98.8983 84.9584 99.1605 85.2207 99.6183 85.2972C99.971 85.2135 100.207 85.0037 100.327 84.6677C100.261 83.8531 100.13 83.04 99.9331 82.2284C99.9855 82.0447 100.038 81.8612 100.09 81.6776C100.507 82.1735 100.953 82.6456 101.428 83.094C102.115 85.2934 101.302 86.3688 98.9888 86.3201C97.7009 85.6577 97.3074 84.6348 97.8085 83.2513C98.2051 82.6653 98.5985 82.0882 98.9888 81.5202Z",
    fill: "#C94933"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.533,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.047 80.8907C129.204 80.886 129.309 80.9647 129.362 81.1268C129.57 81.8992 129.675 82.686 129.677 83.4874C129.673 83.9483 129.568 84.3418 129.362 84.6677C129.607 83.3774 129.502 82.1184 129.047 80.8907Z",
    fill: "#F1F2ED"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7537 80.576C26.3433 83.0293 25.976 85.4949 25.6521 87.9726C25.5358 87.9932 25.4309 87.9669 25.3374 87.8939C25.7297 85.6494 26.0969 83.3936 26.439 81.1268C26.1356 80.6967 26.2405 80.513 26.7537 80.576Z",
    fill: "#EFEDEA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.625 88.6021C112.305 87.7302 111.046 86.7597 109.848 85.6907C109.586 85.4565 109.429 85.168 109.376 84.8251C110.423 84.4847 111.472 84.1962 112.523 83.9595C112.864 84.3006 113.205 84.6414 113.546 84.9825C113.597 85.9555 113.676 86.9261 113.782 87.8939C113.766 88.1444 113.713 88.3805 113.625 88.6021Z",
    fill: "#26496D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5435 84.353C59.3845 84.3268 60.2238 84.3531 61.0615 84.4317C61.4603 84.5129 61.8011 84.6965 62.0844 84.9825C62.503 87.0963 62.3981 89.1946 61.7697 91.2775C61.1806 91.869 60.4724 92.0527 59.6451 91.8283C59.2032 91.7342 58.8098 91.5505 58.4648 91.2775C57.7254 88.9626 57.7517 86.6544 58.5435 84.353Z",
    fill: "#165DA1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7665 84.5103C55.5527 84.4722 56.3133 84.5772 57.0484 84.8251C57.1534 86.9759 57.1534 89.1266 57.0484 91.2774C56.9895 91.4216 56.9109 91.5528 56.8123 91.6709C54.4942 91.8446 53.3926 90.7691 53.5075 88.4447C53.5758 87.6045 53.6545 86.765 53.7435 85.9267C54.0071 85.3782 54.3482 84.9061 54.7665 84.5103Z",
    fill: "#185DA0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.376 84.8251C109.429 85.168 109.586 85.4565 109.848 85.6906C111.046 86.7597 112.305 87.7302 113.625 88.6021C111.461 89.6028 109.205 90.3897 106.858 90.9627C106.188 90.3721 105.453 89.8737 104.654 89.4676C104.08 89.3891 103.503 89.363 102.923 89.3889C102.863 88.5349 102.653 87.7217 102.294 86.9496C102.444 86.642 102.654 86.3796 102.923 86.1628C105.1 85.8176 107.251 85.3718 109.376 84.8251Z",
    fill: "#165DA1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.502,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.362 84.8251C129.46 84.8907 129.513 84.9957 129.52 85.1398C129.481 85.3307 129.376 85.4357 129.205 85.4546C129.257 85.2448 129.31 85.0349 129.362 84.8251Z",
    fill: "#E5E5DF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8942 85.4546C65.7371 85.4023 67.573 85.481 69.4023 85.6906C71.8286 86.0686 72.8515 87.4587 72.4711 89.8611C72.2099 91.4062 71.5541 92.7439 70.504 93.8741C70.2625 94.0194 70.0002 94.0981 69.7171 94.1102C67.4235 93.8101 65.4037 92.9184 63.6581 91.4348C63.6646 90.4286 63.7957 89.4319 64.0516 88.4447C64.8562 88.7159 65.6431 89.0306 66.4122 89.3889C67.0357 88.9047 67.0357 88.4063 66.4122 87.8939C65.6404 87.4421 64.8273 87.101 63.9729 86.8709C63.8945 86.4017 63.8682 85.9295 63.8942 85.4546Z",
    fill: "#165DA1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.716 86.5562C117.151 86.2279 116.653 85.8082 116.221 85.2972C116.169 85.4022 116.116 85.507 116.064 85.612C115.841 85.4683 115.605 85.4683 115.356 85.612C115.608 85.2214 115.975 85.0903 116.457 85.2185C116.909 85.6439 117.329 86.0898 117.716 86.5562Z",
    fill: "#F5F2EA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.876,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.205 85.6119C129.403 85.7887 129.35 85.8935 129.047 85.9267C129.1 85.8217 129.152 85.7169 129.205 85.6119Z",
    fill: "#DEDCDC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.047 86.0841C129.28 86.4317 129.175 86.6415 128.733 86.7136C128.838 86.5038 128.942 86.2939 129.047 86.0841Z",
    fill: "#E4DFDE"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.716 86.5562C119.002 87.5411 120.419 88.3279 121.966 88.9168C122.091 88.9888 122.144 89.0937 122.123 89.2316C121.164 88.8309 120.219 88.3849 119.29 87.8939C118.667 87.5571 118.142 87.1113 117.716 86.5562Z",
    fill: "#ECEBE6"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9987 87.0283C96.2801 86.9835 96.5424 87.0359 96.7856 87.1857C96.4287 87.8791 96.2189 88.6136 96.1561 89.389C93.8611 89.5334 92.6021 90.74 92.3791 93.0086C85.9366 93.5633 79.4843 93.7207 73.022 93.4807C73.9371 91.7604 74.3305 89.9245 74.2023 87.9726C78.0449 87.9699 81.8745 87.9699 85.6907 87.9726C89.1121 87.824 92.5481 87.5093 95.9987 87.0283Z",
    fill: "#165DA1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.356 85.7693C115.56 86.0405 115.665 86.3815 115.671 86.7923C115.67 87.1638 115.618 87.5047 115.513 87.8152C115.403 87.1388 115.351 86.4569 115.356 85.7693Z",
    fill: "#DEDED9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.619 87.3431C51.7998 87.3889 51.9048 87.52 51.9337 87.7365C51.8086 89.0498 51.966 90.3351 52.4059 91.5922C51.4045 94.076 50.7226 96.6466 50.36 99.3036C50.4124 99.5659 50.4649 99.8281 50.5174 100.09C51.5652 97.7819 52.5355 95.4213 53.4288 93.0086C53.5892 92.8218 53.7728 92.6644 53.9796 92.5365C54.4838 92.6416 54.9035 92.8776 55.2386 93.2446C54.7562 99.3011 54.2054 105.36 53.5862 111.421C53.3544 111.659 53.0657 111.764 52.7206 111.736C49.6526 111.173 46.6886 110.281 43.8289 109.061C44.4924 103.711 45.8038 98.5181 47.7633 93.4807C48.4123 91.9729 49.1468 90.5041 49.9665 89.0742C50.4434 88.414 50.9942 87.8371 51.619 87.3431Z",
    fill: "#165DA1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9888 87.3431C100.925 87.3135 101.685 88.2577 101.271 90.1758C101.034 90.9599 100.64 91.6418 100.09 92.2217C99.8281 92.0119 99.5659 92.0119 99.3036 92.2217C98.0008 90.9654 97.66 89.4966 98.2806 87.8152C98.5406 87.6737 98.7767 87.5164 98.9888 87.3431Z",
    fill: "#F8B244"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.733 86.871C128.732 87.3879 128.47 87.8075 127.946 88.13C128.209 87.709 128.471 87.2894 128.733 86.871Z",
    fill: "#EEECE7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3832 87.8152C31.4586 89.7419 35.7077 91.1846 40.1306 92.143C42.1299 92.5547 44.1234 92.9481 46.1108 93.3233C44.2659 98.1232 42.902 103.054 42.0191 108.117C36.1625 107.24 30.6281 105.404 25.416 102.608C26.0487 97.6815 26.7043 92.7505 27.3832 87.8152Z",
    fill: "#FEFEFE"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.788 88.2873C127.704 88.5936 127.494 88.7509 127.159 88.7594C127.279 88.4822 127.489 88.3248 127.788 88.2873Z",
    fill: "#F2EEEE"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.298,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.484 89.2316C124.378 89.3523 124.247 89.4572 124.09 89.5463C124.027 89.5104 124.001 89.4579 124.011 89.3889C124.123 89.2467 124.28 89.1943 124.484 89.2316Z",
    fill: "#FDFEF9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.159 88.7595C126.662 89.2758 126.085 89.4332 125.428 89.2316C126.014 89.1062 126.591 88.9488 127.159 88.7595Z",
    fill: "#F0F1ED"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.914,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6521 88.1299C25.4718 89.281 25.3144 90.435 25.18 91.5922C25.0593 91.4864 24.9543 91.3553 24.8652 91.1988C25.1118 90.3829 25.2692 89.5435 25.3374 88.6808C25.3544 88.4162 25.4593 88.2326 25.6521 88.1299Z",
    fill: "#EEEBE9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.798 89.2316C124.903 89.2316 125.008 89.2316 125.113 89.2316C125.008 89.6513 124.903 89.6513 124.798 89.2316Z",
    fill: "#F6F2E8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.625 90.3332C113.85 90.3932 113.981 90.5505 114.018 90.8053C114.429 95.2584 114.691 99.7175 114.805 104.182C111.466 105.811 107.977 107.018 104.34 107.802C104.049 106.175 103.315 104.784 102.136 103.631C102.356 103.447 102.487 103.211 102.53 102.923C102.614 102.237 102.588 101.555 102.451 100.877C103.674 100.829 104.645 100.305 105.363 99.3036C105.937 98.1513 105.858 97.0496 105.126 95.9987C106.43 95.2552 107.112 94.1273 107.172 92.6151C109.413 92.0524 111.563 91.2918 113.625 90.3332Z",
    fill: "#FEFEFE"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.081 90.8053C105.268 90.7769 105.976 91.7735 105.205 93.7955C104.957 94.038 104.668 94.2216 104.34 94.3463C103.343 94.4944 102.373 94.4157 101.428 94.1102C101.33 93.581 101.277 93.0564 101.271 92.5365C101.754 91.8168 102.357 91.2399 103.081 90.8053Z",
    fill: "#FAB344"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0544 91.1201C96.4489 90.8077 97.4719 91.2798 98.1233 92.5365C98.0419 93.0139 98.0419 93.4861 98.1233 93.9528C97.06 94.5781 95.9321 94.7093 94.7397 94.3463C93.6209 93.1464 93.7259 92.0711 95.0544 91.1201Z",
    fill: "#FAB344"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.924,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.18 91.7496C25.1526 92.1211 25.1002 92.4883 25.0226 92.8512C24.8958 92.6156 24.7909 92.3533 24.7079 92.0643C24.7873 91.841 24.9447 91.7362 25.18 91.7496Z",
    fill: "#E1E1DB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.985 94.7397C115.821 92.589 115.664 90.4382 115.513 88.2873C115.61 88.2699 115.689 88.2174 115.749 88.1299C115.891 89.9653 116.022 91.8013 116.143 93.6381C116.142 94.0354 116.09 94.4028 115.985 94.7397Z",
    fill: "#EDECE8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.914 93.0086C58.1695 92.9865 58.353 93.0915 58.4648 93.3233C58.7871 98.3869 59.1281 103.449 59.4877 108.51C59.4353 108.956 59.3827 109.402 59.3303 109.848C58.1326 109.578 56.926 109.342 55.7107 109.14C55.6227 109.025 55.5703 108.894 55.5533 108.746C56.0615 103.664 56.5074 98.5759 56.891 93.4807C57.252 93.3356 57.5931 93.1782 57.914 93.0086Z",
    fill: "#FCFCFB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3205 93.0086C62.486 92.9851 62.6434 93.0112 62.7926 93.0872C64.2546 94.3346 65.9333 95.1739 67.8286 95.6052C76.2203 95.4833 84.6137 95.2209 93.0086 94.8184C93.4152 95.3545 93.9398 95.748 94.5823 95.9987C93.5638 97.6245 93.8261 99.0146 95.3692 100.169C95.9394 100.473 96.5165 100.761 97.1003 101.035C96.9083 101.833 97.0131 102.593 97.4151 103.317C96.6587 103.856 96.1079 104.564 95.7626 105.441C95.2729 106.771 94.9319 108.134 94.7397 109.533C83.5957 111.076 72.422 111.338 61.2188 110.32C60.8437 104.707 60.4763 99.0941 60.1172 93.4807C60.9209 93.5524 61.6554 93.3951 62.3205 93.0086Z",
    fill: "#FEFEFE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0226 93.0086C24.9176 93.743 24.8128 94.4774 24.7079 95.2118C24.6052 95.0625 24.5527 94.879 24.5505 94.661C24.5571 94.0292 24.7145 93.4783 25.0226 93.0086Z",
    fill: "#E3E1DF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7757 93.4807C100.192 93.7369 100.192 93.9991 99.7757 94.2676C99.3569 94.0045 99.3569 93.7421 99.7757 93.4807Z",
    fill: "#F9B244"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5167 95.0544C98.8111 95.1109 99.0472 95.2683 99.2249 95.5266C99.395 96.558 99.29 97.5548 98.9101 98.5167C98.097 99.3823 97.179 99.5133 96.1561 98.9101C95.3032 97.7855 95.4606 96.7887 96.6282 95.92C97.2803 95.6432 97.9098 95.3547 98.5167 95.0544Z",
    fill: "#FAB344"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.72 95.0544C101.922 95.2362 102.945 95.7607 103.789 96.6282C104.342 97.6426 104.158 98.5082 103.238 99.2249C102.025 99.6289 101.16 99.2354 100.641 98.0446C100.327 97.0234 100.354 96.0267 100.72 95.0544Z",
    fill: "#F9B244"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7079 95.3692C24.5829 95.8889 24.4781 96.4134 24.3931 96.943C24.2926 96.849 24.2402 96.7179 24.2357 96.5495C24.2485 96.065 24.4059 95.6715 24.7079 95.3692Z",
    fill: "#F0EEEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.985 95.0544C116.235 95.2077 116.392 95.4438 116.457 95.7626C116.251 96.1726 116.251 96.566 116.457 96.9429C116.507 97.5004 116.454 98.0249 116.3 98.5167C116.21 97.36 116.105 96.206 115.985 95.0544Z",
    fill: "#EAE9E6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.457 96.7856C116.667 96.8906 116.667 96.8906 116.457 96.7856Z",
    fill: "#F7ECCF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3931 97.1003C24.1844 98.0355 24.0271 98.9797 23.921 99.9331C23.8192 99.8113 23.7668 99.6539 23.7636 99.461C23.8497 98.9375 23.9284 98.4128 23.9997 97.8872C24.0075 97.5341 24.1386 97.2717 24.3931 97.1003Z",
    fill: "#E9E7E4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.831,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.457 100.72C116.434 100.087 116.382 99.458 116.3 98.8314C116.397 98.814 116.476 98.7616 116.536 98.6741C116.664 99.3854 116.638 100.067 116.457 100.72Z",
    fill: "#EFEEEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.408,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.921 100.09C23.8686 100.405 23.816 100.72 23.7636 101.035C23.6618 100.913 23.6094 100.756 23.6062 100.563C23.6283 100.322 23.7332 100.164 23.921 100.09Z",
    fill: "#E1DDD9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4609 100.405C101.094 100.469 101.566 101.256 100.877 102.766C100.07 103.437 99.3623 103.332 98.7528 102.451C98.4976 101.573 98.7337 100.891 99.4609 100.405Z",
    fill: "#CC4933"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.816,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.457 100.877C116.658 101.065 116.763 101.327 116.772 101.664C116.771 101.958 116.719 102.221 116.615 102.451C116.562 101.927 116.51 101.402 116.457 100.877Z",
    fill: "#E3E0DF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7636 101.192C23.5902 101.86 23.5641 102.542 23.6849 103.238C24.062 103.642 24.4554 104.009 24.8653 104.34C23.2405 103.693 22.8734 102.643 23.7636 101.192Z",
    fill: "#E8E3DF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.349 107.644C101.45 108.585 101.529 109.529 101.586 110.477C101.715 109.452 101.688 108.455 101.507 107.487C101.481 106.803 101.507 106.121 101.586 105.441C102.075 106.053 102.442 106.735 102.687 107.487C103.555 111.006 103.974 114.573 103.946 118.189C103.353 118.325 102.75 118.43 102.136 118.503C102.192 116.601 102.061 114.713 101.743 112.838C101.685 112.616 101.554 112.459 101.349 112.366C101.219 113.989 101.14 115.616 101.113 117.244C101.236 118.958 100.475 119.561 98.8314 119.054C98.6478 118.975 98.5167 118.844 98.438 118.661C98.3593 115.828 98.333 112.996 98.3593 110.162C98.6294 108.567 98.7605 106.941 98.7528 105.284C98.4297 106.668 98.246 108.084 98.2019 109.533C98.1126 112.479 97.9026 115.417 97.5724 118.346C96.8277 118.365 96.0934 118.286 95.3692 118.11C95.1751 117.843 95.0702 117.528 95.0544 117.166C95.3939 113.737 95.9973 110.353 96.8643 107.015C97.0918 106.166 97.5377 105.458 98.2019 104.89C98.9328 104.688 99.7197 104.635 100.563 104.733C100.806 104.924 100.99 105.16 101.113 105.441C101.27 106.168 101.348 106.902 101.349 107.644Z",
    fill: "#CC4933"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.251,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.615 102.766C116.819 103.037 116.924 103.378 116.93 103.789C116.903 104.13 116.877 104.471 116.851 104.812C116.791 104.899 116.712 104.952 116.615 104.969C116.825 104.235 116.825 103.5 116.615 102.766Z",
    fill: "#F1F2EB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8652 104.34C25.8595 104.732 26.8038 105.204 27.698 105.756C26.6615 105.447 25.7173 104.975 24.8652 104.34Z",
    fill: "#ECE9E7"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.784,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.698 105.756C28.6987 105.999 29.5904 106.419 30.3734 107.015C29.4164 106.714 28.5245 106.295 27.698 105.756Z",
    fill: "#EBE9E7"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.457 105.126C116.526 105.116 116.579 105.142 116.615 105.205C115.068 106.293 113.389 107.133 111.579 107.723C111.03 108.851 110.348 109.874 109.533 110.792C110.179 109.738 110.808 108.663 111.421 107.566C113.21 106.96 114.889 106.147 116.457 105.126Z",
    fill: "#EFEEEA"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3593 110.162C98.4015 109.911 98.349 109.701 98.202 109.533C98.246 108.084 98.4297 106.668 98.7528 105.284C98.7605 106.941 98.6294 108.567 98.3593 110.162Z",
    fill: "#431C15"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3734 107.015C30.702 107.304 30.9117 107.671 31.0029 108.117C30.6615 107.827 30.4517 107.46 30.3734 107.015Z",
    fill: "#EEEBE9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9528 113.153C93.8035 113.05 93.62 112.997 93.402 112.995C88.476 113.543 83.5448 113.91 78.6088 114.097C76.3988 114.064 74.2479 114.064 72.1564 114.097C66.9638 113.782 61.7704 113.363 56.5763 112.838C56.4021 112.851 56.2447 112.904 56.1042 112.995C55.9411 114.233 55.2329 114.915 53.9796 115.041C51.7756 114.49 49.5723 113.939 47.3699 113.389C45.3865 112.675 43.393 111.993 41.3896 111.343C39.3492 110.904 37.3296 110.405 35.3307 109.848C35.0913 109.851 34.8552 109.903 34.6225 110.005C34.0437 109.35 33.5191 108.641 33.0487 107.88C36.056 108.658 39.0985 109.34 42.1765 109.926C42.6215 110.28 43.0937 110.595 43.5929 110.871C46.767 112.031 50.0194 112.897 53.3501 113.467C53.8664 113.406 54.3124 113.196 54.6878 112.838C55.0156 112.327 55.2517 111.776 55.396 111.185C55.6844 111.159 55.9731 111.133 56.2615 111.107C58.8368 111.597 61.4335 111.99 64.0516 112.287C71.0282 112.805 78.0051 112.805 84.9825 112.287C88.0801 112.011 91.1752 111.723 94.2676 111.421C94.2446 112.033 94.1396 112.61 93.9528 113.153Z",
    fill: "#458693"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.015 110.949C106.702 110.639 106.413 110.639 106.149 110.949C105.74 110.834 105.347 110.782 104.969 110.792C104.849 110.448 104.744 110.081 104.654 109.69C104.687 109.598 104.74 109.519 104.812 109.454C106.112 109.149 107.397 108.808 108.667 108.431C108.319 109.386 107.769 110.225 107.015 110.949Z",
    fill: "#458692"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1602 108.274C31.345 108.434 31.4498 108.643 31.475 108.903C31.2646 108.775 31.1072 108.592 31.0029 108.353C31.0388 108.29 31.0913 108.264 31.1602 108.274Z",
    fill: "#EAE8E4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.753,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.475 108.903C31.6963 108.978 31.8012 109.135 31.7898 109.376C31.5685 109.301 31.4635 109.144 31.475 108.903Z",
    fill: "#F4F1ED"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.507 107.487C101.688 108.455 101.715 109.452 101.586 110.477C101.529 109.529 101.45 108.585 101.349 107.644C101.454 107.644 101.507 107.592 101.507 107.487Z",
    fill: "#420F03"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7897 109.376C32.1119 109.698 32.3742 110.065 32.5766 110.477C32.1323 110.242 31.87 109.875 31.7897 109.376Z",
    fill: "#F0F0EC"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9528 113.153C93.7221 114.453 93.5648 115.764 93.4807 117.087C93.4845 117.547 93.5369 117.992 93.6381 118.425C90.6676 119.992 87.5201 121.094 84.1956 121.729C73.0714 123.795 62.0551 123.323 51.1469 120.313C45.9796 118.884 41.3633 116.471 37.2979 113.074C36.3731 112.071 35.4814 111.048 34.6225 110.005C34.8553 109.903 35.0913 109.851 35.3307 109.848C37.3297 110.405 39.3493 110.904 41.3896 111.343C43.393 111.993 45.3865 112.675 47.3699 113.389C49.5723 113.939 51.7756 114.49 53.9796 115.041C55.2329 114.915 55.9411 114.233 56.1042 112.995C56.2447 112.904 56.4021 112.851 56.5763 112.838C61.7705 113.363 66.9638 113.782 72.1564 114.097C74.2479 114.064 76.3988 114.064 78.6088 114.097C83.5449 113.91 88.476 113.543 93.402 112.995C93.62 112.997 93.8035 113.05 93.9528 113.153Z",
    fill: "#5EB7B2"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5766 110.477C32.8539 110.597 33.0113 110.807 33.0487 111.107C32.7714 110.987 32.6141 110.777 32.5766 110.477Z",
    fill: "#E9E8E4"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.015 110.949C106.487 111.685 105.884 112.367 105.205 112.995C105.049 112.268 104.97 111.534 104.969 110.792C105.347 110.782 105.74 110.834 106.149 110.949C106.413 110.639 106.702 110.639 107.015 110.949Z",
    fill: "#5EB6B1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.816,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.533 110.792C109.495 111.092 109.338 111.302 109.061 111.421C109.098 111.122 109.256 110.912 109.533 110.792Z",
    fill: "#F2EFEB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.061 111.421C108.97 111.775 108.76 112.038 108.431 112.208C108.523 111.854 108.732 111.592 109.061 111.421Z",
    fill: "#F4F2EF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.314,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0487 111.107C33.8372 111.895 34.5717 112.735 35.252 113.625C34.3507 112.933 33.6164 112.094 33.0487 111.107Z",
    fill: "#E6E2DF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.431 112.208C108.067 112.835 107.595 113.36 107.015 113.782C107.375 113.159 107.847 112.635 108.431 112.208Z",
    fill: "#EAE9E7"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.251,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.252 113.625C35.4094 113.677 35.5143 113.782 35.5667 113.939C35.357 113.939 35.252 113.834 35.252 113.625Z",
    fill: "#FAFCF7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.015 113.782C107.015 113.992 106.91 114.097 106.7 114.097C106.753 113.939 106.858 113.834 107.015 113.782Z",
    fill: "#FCFDF8"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.543 114.254C106.49 114.621 106.28 114.831 105.913 114.884C106.071 114.621 106.28 114.412 106.543 114.254Z",
    fill: "#FAFCF4"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.845,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.756 115.041C105.559 115.33 105.559 115.619 105.756 115.907C105.662 115.98 105.557 116.006 105.441 115.985C105.366 115.579 105.471 115.264 105.756 115.041Z",
    fill: "#F4F4F0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.77 116.3C38.2123 116.351 38.6321 116.482 39.029 116.693C40.9804 117.931 42.9739 119.085 45.0092 120.156C42.7288 122.344 40.0011 123.393 36.8257 123.303C36.7288 123.083 36.6764 122.847 36.6683 122.595C36.9112 121.536 37.2783 120.539 37.77 119.605C37.374 119.645 37.0067 119.776 36.6683 119.998C35.9908 120.754 35.4139 121.567 34.9372 122.438C33.9824 121.786 33.6414 120.894 33.9143 119.762C34.2902 118.721 34.946 117.908 35.8815 117.323C36.5459 117.018 37.1754 116.676 37.77 116.3Z",
    fill: "#F6C59B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.284 118.975C105.434 118.098 105.486 117.206 105.441 116.3C105.538 116.283 105.617 116.23 105.677 116.143C105.782 116.982 105.782 117.821 105.677 118.661C105.612 118.858 105.481 118.963 105.284 118.975Z",
    fill: "#E0DCD8"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5667 113.939C36.0622 114.093 36.3506 114.407 36.4323 114.884C34.6494 115.854 33.2593 117.217 32.2619 118.975C32.1764 118.966 32.124 118.914 32.1045 118.818C33.1011 117.087 34.4651 115.723 36.1962 114.726C35.9827 114.461 35.7729 114.199 35.5667 113.939Z",
    fill: "#E1DDD9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.878,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2619 119.133C32.2095 119.238 32.1569 119.343 32.1045 119.448C31.9067 119.271 31.9591 119.166 32.2619 119.133Z",
    fill: "#E3E3DF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.314,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.284 119.133C105.432 119.263 105.379 119.368 105.126 119.448C105.099 119.291 105.152 119.187 105.284 119.133Z",
    fill: "#E0DCD8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.441 119.762C105.504 119.601 105.608 119.575 105.756 119.684C105.662 119.757 105.557 119.783 105.441 119.762Z",
    fill: "#FDEECD"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.385 119.605C106.595 119.71 106.595 119.71 106.385 119.605Z",
    fill: "#F9FFF0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3692 119.762C96.7854 120.077 98.2018 120.392 99.6183 120.707C100.509 120.667 101.348 120.483 102.136 120.156C103.426 121.282 103.715 122.62 103.002 124.169C102.681 124.542 102.314 124.857 101.9 125.113C101.713 124.237 101.398 123.398 100.956 122.595C100.633 122.219 100.266 121.905 99.8544 121.651C99.6529 121.669 99.5219 121.774 99.461 121.966C100.09 123.033 100.3 124.161 100.09 125.349C96.8457 125.248 94.1703 123.963 92.0643 121.493C93.1792 120.947 94.2808 120.369 95.3692 119.762Z",
    fill: "#F5C59B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.644 119.92C107.854 120.025 107.854 120.025 107.644 119.92Z",
    fill: "#F9EDCC"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.126 120.077C105.336 120.182 105.336 120.182 105.126 120.077Z",
    fill: "#EDCBA6"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6881 120.234C30.8979 120.339 30.8979 120.339 30.6881 120.234Z",
    fill: "#FCE9CA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.376 120.234C109.585 120.339 109.585 120.339 109.376 120.234Z",
    fill: "#F9E8CA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7439 120.549C29.8063 120.388 29.9112 120.362 30.0586 120.471C29.9651 120.544 29.8602 120.57 29.7439 120.549Z",
    fill: "#F4E3CD"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.376 120.392C109.271 120.497 109.271 120.497 109.376 120.392Z",
    fill: "#F0CCA7"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.848 120.392C110.057 120.497 110.057 120.497 109.848 120.392Z",
    fill: "#F4E1CB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1143 120.549C29.3241 120.654 29.3241 120.654 29.1143 120.549Z",
    fill: "#F8E5C8"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.635 120.549C110.844 120.654 110.844 120.654 110.635 120.549Z",
    fill: "#F8E8CC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3275 120.707C28.7211 120.708 28.7474 120.813 28.4062 121.021C28.3331 120.928 28.3069 120.823 28.3275 120.707Z",
    fill: "#F1DDC2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.264 120.707C111.474 120.812 111.474 120.812 111.264 120.707Z",
    fill: "#F6E7CE"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.698 121.021C27.7605 120.86 27.8653 120.834 28.0127 120.943C27.9193 121.016 27.8143 121.042 27.698 121.021Z",
    fill: "#FAE6C9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.894 120.864C112.103 120.969 112.103 120.969 111.894 120.864Z",
    fill: "#FAE9CC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.366 121.021C112.575 121.126 112.575 121.126 112.366 121.021Z",
    fill: "#F3E1C9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9436 121.493C48.8991 121.618 48.8204 121.723 48.7075 121.808C48.4808 121.593 48.2184 121.435 47.9207 121.336C47.5223 121.162 47.0765 121.162 46.583 121.336C46.6917 121.097 46.8754 120.939 47.1338 120.864C47.7474 121.06 48.3508 121.27 48.9436 121.493Z",
    fill: "#EFE6CD"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.995 121.179C113.205 121.284 113.205 121.284 112.995 121.179Z",
    fill: "#FAEDCF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1242 121.336C26.334 121.441 26.334 121.441 26.1242 121.336Z",
    fill: "#F6E5C9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.467 121.336C113.677 121.441 113.677 121.441 113.467 121.336Z",
    fill: "#F6E6CE"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4948 121.493C25.7045 121.598 25.7045 121.598 25.4948 121.493Z",
    fill: "#F9ECCC"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.583 121.493C46.7928 121.598 46.7928 121.598 46.583 121.493Z",
    fill: "#E7CFA7"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.939 121.493C114.149 121.598 114.149 121.598 113.939 121.493Z",
    fill: "#F9E7CA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7079 121.966C24.6029 121.756 24.6029 121.756 24.7079 121.966Z",
    fill: "#FAEBCD"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.502,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1045 119.605C31.8931 120.701 32.0505 121.75 32.5766 122.752C32.3338 122.454 32.0716 122.166 31.7897 121.887C31.9828 121.637 31.9304 121.427 31.6324 121.257C31.6841 120.645 31.8415 120.094 32.1045 119.605Z",
    fill: "#EEE6CE"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7079 121.966C24.9176 122.071 24.9176 122.071 24.7079 121.966Z",
    fill: "#EECDA6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.569 122.123C114.631 121.962 114.736 121.935 114.884 122.044C114.79 122.117 114.685 122.144 114.569 122.123Z",
    fill: "#F6CFA7"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.314,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0784 122.28C24.1408 122.119 24.2457 122.093 24.3931 122.202C24.2996 122.275 24.1947 122.301 24.0784 122.28Z",
    fill: "#EFCBA4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2682 121.651C46.0462 122.031 45.7314 122.293 45.324 122.438C45.546 122.058 45.8608 121.795 46.2682 121.651Z",
    fill: "#EFE7D0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.671 122.28C115.566 122.071 115.566 122.071 115.671 122.28Z",
    fill: "#FCF1CE"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.671 122.28C115.88 122.385 115.88 122.385 115.671 122.28Z",
    fill: "#F2DECA"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.324 122.438C45.2377 122.757 45.028 122.915 44.6945 122.91C44.8144 122.633 45.0243 122.475 45.324 122.438Z",
    fill: "#EBE2C8"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2125 122.752C47.4222 122.857 47.4222 122.857 47.2125 122.752Z",
    fill: "#E2C7A6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8194 123.067C23.0291 123.172 23.0291 123.172 22.8194 123.067Z",
    fill: "#F9E8C9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6945 122.91C44.3823 123.329 43.9625 123.591 43.4355 123.697C43.7705 123.311 44.1903 123.049 44.6945 122.91Z",
    fill: "#EFE8CE"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.101 121.493C54.7353 123.254 60.5058 124.304 66.4122 124.641C64.9578 124.728 63.489 124.728 62.0057 124.641C61.5204 124.349 61.022 124.296 60.5107 124.484C60.2203 124.192 59.9056 124.14 59.5664 124.326C59.2761 124.035 58.9613 123.983 58.6222 124.169C57.7273 123.795 56.8094 123.638 55.8681 123.697C55.6176 123.372 55.3291 123.32 55.0025 123.539C54.896 123.195 54.7123 123.142 54.4517 123.382C54.2978 123.307 54.1667 123.202 54.0583 123.067C52.6994 122.832 51.3354 122.464 49.9665 121.966C49.9141 122.018 49.8616 122.071 49.8092 122.123C49.4758 122 49.2398 121.79 49.101 121.493Z",
    fill: "#E9E0C8"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9627 123.067C91.3299 123.33 91.6446 123.644 91.907 124.011C91.4348 123.854 91.1201 123.539 90.9627 123.067Z",
    fill: "#F8F3D9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.188,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.615 123.382C116.825 123.487 116.825 123.487 116.615 123.382Z",
    fill: "#F0CEA5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.648 122.752C89.9243 122.156 89.1637 122.209 88.366 122.91C88.0513 122.91 87.7365 122.91 87.4218 122.91C87.0943 123.022 86.7534 123.18 86.3988 123.382C85.9569 123.24 85.5635 123.345 85.2185 123.697C85.1302 123.615 85.0253 123.562 84.9038 123.539C84.4373 123.6 84.0177 123.757 83.6448 124.011C83.5565 123.929 83.4515 123.877 83.33 123.854C82.8152 123.978 82.2906 124.136 81.7563 124.326C81.408 124.131 81.0932 124.184 80.812 124.484C80.4963 124.247 80.2341 124.3 80.0251 124.641C79.6929 124.629 79.3782 124.576 79.0809 124.484C78.4915 124.609 77.8882 124.688 77.2711 124.72C77.1924 124.798 77.1137 124.877 77.035 124.956C76.33 124.717 75.6481 124.769 74.9891 125.113C72.4464 124.914 69.9284 124.914 67.4352 125.113C67.163 125.038 66.9796 124.881 66.8843 124.641C74.7591 125.142 82.4704 124.25 90.0185 121.966C90.3507 122.139 90.5606 122.402 90.648 122.752Z",
    fill: "#EAE1C9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.907 124.011C92.3676 124.209 92.7349 124.524 93.0086 124.956C92.5479 124.758 92.1806 124.443 91.907 124.011Z",
    fill: "#D2C5B3"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4489 124.641C23.6586 124.746 23.6586 124.746 23.4489 124.641Z",
    fill: "#F8D6A6"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5766 122.752C33.5987 123.998 34.9102 124.759 36.511 125.034C38.9555 125.289 41.2635 124.843 43.4355 123.697C43.2866 123.922 43.1031 124.132 42.8847 124.326C42.8323 124.274 42.7797 124.221 42.7273 124.169C41.8354 124.503 41.0223 124.871 40.288 125.27C39.6165 125.177 38.9607 125.282 38.3208 125.585C37.5295 125.453 36.7426 125.296 35.9602 125.113C35.895 125.185 35.8163 125.238 35.7241 125.27C35.0307 124.891 34.3488 124.498 33.6782 124.09C33.2144 123.707 32.8473 123.261 32.5766 122.752Z",
    fill: "#EBDFC6"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.3 124.798C116.51 124.903 116.51 124.903 116.3 124.798Z",
    fill: "#FAE8CD"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7636 125.113C23.9734 125.218 23.9734 125.218 23.7636 125.113Z",
    fill: "#FCE9C9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0086 124.956C93.2489 124.944 93.4063 125.049 93.4807 125.27C93.2404 125.282 93.083 125.177 93.0086 124.956Z",
    fill: "#F0E3CA"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.126 119.448C105.068 119.753 104.963 120.042 104.812 120.313C104.987 120.541 105.144 120.751 105.284 120.943C105.231 120.995 105.179 121.048 105.126 121.1C105.259 121.525 105.417 121.945 105.599 122.359C105.564 122.796 105.564 123.242 105.599 123.697C105.524 123.851 105.419 123.982 105.284 124.09C105.429 124.224 105.429 124.381 105.284 124.562C105.103 124.941 104.841 125.229 104.497 125.428C105.569 123.548 105.516 121.685 104.34 119.841C104.561 119.625 104.824 119.494 105.126 119.448Z",
    fill: "#EDE0C6"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.816,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4807 125.27C93.721 125.259 93.8784 125.364 93.9528 125.585C93.7125 125.597 93.5552 125.492 93.4807 125.27Z",
    fill: "#F0E3CB"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7079 125.585C24.9176 125.69 24.9176 125.69 24.7079 125.585Z",
    fill: "#F4E1CA"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.041 125.585C115.251 125.69 115.251 125.69 115.041 125.585Z",
    fill: "#F2E3CA"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0226 125.743C25.2324 125.848 25.2324 125.848 25.0226 125.743Z",
    fill: "#FCE8CB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4948 125.9C25.7045 126.005 25.7045 126.005 25.4948 125.9Z",
    fill: "#F1DEC7"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.188,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9669 125.9C26.1766 126.005 26.1766 126.005 25.9669 125.9Z",
    fill: "#EDCBA5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3233 125.9C93.5331 126.005 93.5331 126.005 93.3233 125.9Z",
    fill: "#E4C7A7"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.412 125.9C114.621 126.005 114.621 126.005 114.412 125.9Z",
    fill: "#F6E6CD"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9668 126.057C25.8619 126.162 25.8619 126.162 25.9668 126.057Z",
    fill: "#FAECCF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.025 125.9C103.867 126.086 103.736 126.296 103.631 126.529C103.571 126.442 103.492 126.39 103.395 126.372C103.515 126.095 103.725 125.937 104.025 125.9Z",
    fill: "#E2DAC3"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2816 126.215C26.4914 126.32 26.4914 126.32 26.2816 126.215Z",
    fill: "#F6E5CE"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.625 126.215C113.834 126.32 113.834 126.32 113.625 126.215Z",
    fill: "#EDDEC7"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2259 126.529C27.4356 126.634 27.4356 126.634 27.2259 126.529Z",
    fill: "#F4E5CD"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.68 126.529C112.89 126.634 112.89 126.634 112.68 126.529Z",
    fill: "#F3E5C7"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9528 125.585C94.5977 125.829 95.2272 126.117 95.8413 126.451C98.3823 127.413 100.9 127.386 103.395 126.372C102.69 126.997 101.85 127.338 100.877 127.395C99.7812 127.516 98.7057 127.438 97.6511 127.159C97.4398 127.271 97.23 127.219 97.0216 127.002C96.8565 127.162 96.6729 127.188 96.4708 127.08C96.603 126.818 96.5243 126.792 96.2348 127.002C95.971 126.913 95.7612 126.756 95.6053 126.529C95.4454 126.708 95.3404 126.655 95.2905 126.372C95.2381 126.424 95.1855 126.477 95.1331 126.529C94.7367 126.191 94.3433 125.876 93.9528 125.585Z",
    fill: "#E6D9BE"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.366 126.687C112.575 126.792 112.575 126.792 112.366 126.687Z",
    fill: "#FAE7C9"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1701 126.844C28.3799 126.949 28.3799 126.949 28.1701 126.844Z",
    fill: "#F8ECCF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6422 127.002C28.852 127.107 28.852 127.107 28.6422 127.002Z",
    fill: "#FAECCB"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2717 127.002C29.4815 127.107 29.4815 127.107 29.2717 127.002Z",
    fill: "#EBCDA7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.157,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.421 127.002C111.631 127.107 111.631 127.107 111.421 127.002Z",
    fill: "#FAF5CC"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0586 127.159C30.2684 127.264 30.2684 127.264 30.0586 127.159Z",
    fill: "#F0CEA6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.477 127.159C110.687 127.264 110.687 127.264 110.477 127.159Z",
    fill: "#F0E2CA"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0586 127.316C29.9536 127.421 29.9536 127.421 30.0586 127.316Z",
    fill: "#FCEDCF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6881 127.474C30.8979 127.579 30.8979 127.579 30.6881 127.474Z",
    fill: "#F3E3C7"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.218 127.474C109.428 127.579 109.428 127.579 109.218 127.474Z",
    fill: "#F7E8CE"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1602 127.631C31.37 127.736 31.37 127.736 31.1602 127.631Z",
    fill: "#FAE9CF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.589 127.631C108.798 127.736 108.798 127.736 108.589 127.631Z",
    fill: "#F8E5CA"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.802 127.788C108.012 127.893 108.012 127.893 107.802 127.788Z",
    fill: "#F7E7CD"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8914 127.946C33.1011 128.051 33.1011 128.051 32.8914 127.946Z",
    fill: "#F8E9CD"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.172 127.946C107.382 128.051 107.382 128.051 107.172 127.946Z",
    fill: "#FAE9CE"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6225 128.261C34.8323 128.366 34.8323 128.366 34.6225 128.261Z",
    fill: "#FCEECF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.441 128.261C105.651 128.366 105.651 128.366 105.441 128.261Z",
    fill: "#F8E8C7"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5667 128.418C35.7765 128.523 35.7765 128.523 35.5667 128.418Z",
    fill: "#F8E7CF"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3536 128.575C36.5634 128.68 36.5634 128.68 36.3536 128.575Z",
    fill: "#F4E3C9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.395 128.575C103.605 128.68 103.605 128.68 103.395 128.575Z",
    fill: "#FAE7C8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6126 128.89C37.6751 128.729 37.7799 128.702 37.9274 128.811C37.8339 128.884 37.7289 128.911 37.6126 128.89Z",
    fill: "#F7E3CC"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.294 128.733C102.503 128.838 102.503 128.838 102.294 128.733Z",
    fill: "#F6E7CE"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7142 129.047C38.7767 128.886 38.8815 128.86 39.029 128.969C38.9355 129.042 38.8305 129.068 38.7142 129.047Z",
    fill: "#FBEACD"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.094,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.349 129.047C101.412 128.886 101.517 128.86 101.664 128.969C101.571 129.042 101.466 129.068 101.349 129.047Z",
    fill: "#FBEACB"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.088,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9732 129.205C40.0914 129.036 40.2488 129.01 40.4454 129.126C40.2962 129.202 40.1388 129.228 39.9732 129.205Z",
    fill: "#F2E3CB"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0749 129.362C41.1373 129.201 41.2421 129.175 41.3896 129.283C41.2961 129.357 41.1912 129.383 41.0749 129.362Z",
    fill: "#FDE6C9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.251,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1003 129.205C97.3101 129.31 97.3101 129.31 97.1003 129.205Z",
    fill: "#EAC8A4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.035,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9888 129.362C99.0513 129.201 99.1561 129.175 99.3036 129.283C99.2101 129.357 99.1051 129.383 98.9888 129.362Z",
    fill: "#FBEACD"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5724 129.362C97.7822 129.467 97.7822 129.467 97.5724 129.362Z",
    fill: "#F7E3CE"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.063,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2118 129.677C95.2743 129.516 95.3791 129.489 95.5266 129.598C95.4331 129.671 95.3281 129.698 95.2118 129.677Z",
    fill: "#F5CFA7"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6938 129.992C92.812 129.823 92.9694 129.797 93.1659 129.913C93.0168 129.989 92.8594 130.015 92.6938 129.992Z",
    fill: "#FAE6CB"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M644.424 65.976C647.656 65.976 650.376 66.952 652.584 68.904C654.792 70.824 655.896 73.512 655.896 76.968C655.896 80.424 654.728 83.128 652.392 85.08C650.088 87.032 647.256 88.008 643.896 88.008C641.176 88.008 638.776 87.4 636.696 86.184C634.616 84.968 633.112 83.176 632.184 80.808L637.848 77.496C638.68 80.184 640.696 81.528 643.896 81.528C645.592 81.528 646.904 81.128 647.832 80.328C648.792 79.496 649.272 78.376 649.272 76.968C649.272 75.592 648.808 74.488 647.88 73.656C646.952 72.824 645.688 72.408 644.088 72.408H633.912L635.256 53.736H654.312V59.928H641.4L640.968 65.976H644.424Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M607.389 87.336V82.392L618.861 70.584C621.421 67.896 622.701 65.656 622.701 63.864C622.701 62.552 622.285 61.496 621.453 60.696C620.653 59.896 619.613 59.496 618.333 59.496C615.805 59.496 613.933 60.808 612.717 63.432L607.149 60.168C608.205 57.864 609.725 56.104 611.709 54.888C613.693 53.672 615.869 53.064 618.237 53.064C621.277 53.064 623.885 54.024 626.061 55.944C628.237 57.832 629.325 60.392 629.325 63.624C629.325 67.112 627.485 70.696 623.805 74.376L617.229 80.952H629.853V87.336H607.389Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M591.822 88.008C587.63 88.008 584.334 86.424 581.934 83.256C579.566 80.056 578.382 75.816 578.382 70.536C578.382 65.256 579.566 61.032 581.934 57.864C584.334 54.664 587.63 53.064 591.822 53.064C596.046 53.064 599.342 54.664 601.71 57.864C604.078 61.032 605.262 65.256 605.262 70.536C605.262 75.816 604.078 80.056 601.71 83.256C599.342 86.424 596.046 88.008 591.822 88.008ZM586.734 78.744C587.886 80.6 589.582 81.528 591.822 81.528C594.062 81.528 595.758 80.584 596.91 78.696C598.094 76.808 598.686 74.088 598.686 70.536C598.686 66.952 598.094 64.216 596.91 62.328C595.758 60.44 594.062 59.496 591.822 59.496C589.582 59.496 587.886 60.44 586.734 62.328C585.582 64.216 585.006 66.952 585.006 70.536C585.006 74.12 585.582 76.856 586.734 78.744Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M552.967 87.336V82.392L564.439 70.584C566.999 67.896 568.279 65.656 568.279 63.864C568.279 62.552 567.863 61.496 567.031 60.696C566.231 59.896 565.191 59.496 563.911 59.496C561.383 59.496 559.511 60.808 558.295 63.432L552.727 60.168C553.783 57.864 555.303 56.104 557.287 54.888C559.271 53.672 561.447 53.064 563.815 53.064C566.855 53.064 569.463 54.024 571.639 55.944C573.815 57.832 574.903 60.392 574.903 63.624C574.903 67.112 573.063 70.696 569.383 74.376L562.807 80.952H575.431V87.336H552.967Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M530.696 63.336H536.888V87.336H530.696V84.504C528.84 86.84 526.232 88.008 522.872 88.008C519.672 88.008 516.92 86.792 514.616 84.36C512.344 81.896 511.208 78.888 511.208 75.336C511.208 71.784 512.344 68.792 514.616 66.36C516.92 63.896 519.672 62.664 522.872 62.664C526.232 62.664 528.84 63.832 530.696 66.168V63.336ZM519.272 80.232C520.52 81.48 522.104 82.104 524.024 82.104C525.944 82.104 527.528 81.48 528.776 80.232C530.056 78.952 530.696 77.32 530.696 75.336C530.696 73.352 530.056 71.736 528.776 70.488C527.528 69.208 525.944 68.568 524.024 68.568C522.104 68.568 520.52 69.208 519.272 70.488C518.024 71.736 517.4 73.352 517.4 75.336C517.4 77.32 518.024 78.952 519.272 80.232Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M489.985 77.88C490.817 80.888 493.073 82.392 496.753 82.392C499.121 82.392 500.913 81.592 502.129 79.992L507.121 82.872C504.753 86.296 501.265 88.008 496.657 88.008C492.689 88.008 489.505 86.808 487.105 84.408C484.705 82.008 483.505 78.984 483.505 75.336C483.505 71.72 484.689 68.712 487.057 66.312C489.425 63.88 492.465 62.664 496.177 62.664C499.697 62.664 502.593 63.88 504.865 66.312C507.169 68.744 508.321 71.752 508.321 75.336C508.321 76.136 508.241 76.984 508.081 77.88H489.985ZM489.889 73.08H502.129C501.777 71.448 501.041 70.232 499.921 69.432C498.833 68.632 497.585 68.232 496.177 68.232C494.513 68.232 493.137 68.664 492.049 69.528C490.961 70.36 490.241 71.544 489.889 73.08Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M474.726 67.464C475.302 65.928 476.246 64.776 477.558 64.008C478.902 63.24 480.39 62.856 482.022 62.856V69.768C480.134 69.544 478.438 69.928 476.934 70.92C475.462 71.912 474.726 73.56 474.726 75.864V87.336H468.534V63.336H474.726V67.464Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M460.482 84.36C458.018 86.792 455.01 88.008 451.458 88.008C447.906 88.008 444.898 86.792 442.434 84.36C440.002 81.896 438.786 78.888 438.786 75.336C438.786 71.784 440.002 68.792 442.434 66.36C444.898 63.896 447.906 62.664 451.458 62.664C455.01 62.664 458.018 63.896 460.482 66.36C462.946 68.792 464.178 71.784 464.178 75.336C464.178 78.888 462.946 81.896 460.482 84.36ZM446.802 80.088C448.05 81.336 449.602 81.96 451.458 81.96C453.314 81.96 454.866 81.336 456.114 80.088C457.362 78.84 457.986 77.256 457.986 75.336C457.986 73.416 457.362 71.832 456.114 70.584C454.866 69.336 453.314 68.712 451.458 68.712C449.602 68.712 448.05 69.336 446.802 70.584C445.586 71.832 444.978 73.416 444.978 75.336C444.978 77.256 445.586 78.84 446.802 80.088Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M439.203 87.336H431.571L419.571 71.592V87.336H412.947V53.736H419.571V68.568L431.091 53.736H438.723L426.291 70.056L439.203 87.336Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M386.3 62.664C388.924 62.664 391.084 63.544 392.78 65.304C394.508 67.064 395.372 69.496 395.372 72.6V87.336H389.18V73.368C389.18 71.768 388.748 70.552 387.884 69.72C387.02 68.856 385.868 68.424 384.428 68.424C382.828 68.424 381.548 68.92 380.588 69.912C379.628 70.904 379.148 72.392 379.148 74.376V87.336H372.956V63.336H379.148V66.024C380.652 63.784 383.036 62.664 386.3 62.664Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M364.904 84.36C362.44 86.792 359.432 88.008 355.88 88.008C352.328 88.008 349.32 86.792 346.856 84.36C344.424 81.896 343.208 78.888 343.208 75.336C343.208 71.784 344.424 68.792 346.856 66.36C349.32 63.896 352.328 62.664 355.88 62.664C359.432 62.664 362.44 63.896 364.904 66.36C367.368 68.792 368.6 71.784 368.6 75.336C368.6 78.888 367.368 81.896 364.904 84.36ZM351.224 80.088C352.472 81.336 354.024 81.96 355.88 81.96C357.736 81.96 359.288 81.336 360.536 80.088C361.784 78.84 362.408 77.256 362.408 75.336C362.408 73.416 361.784 71.832 360.536 70.584C359.288 69.336 357.736 68.712 355.88 68.712C354.024 68.712 352.472 69.336 351.224 70.584C350.008 71.832 349.4 73.416 349.4 75.336C349.4 77.256 350.008 78.84 351.224 80.088Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M326.086 88.008C321.03 88.008 316.854 86.328 313.558 82.968C310.262 79.608 308.614 75.464 308.614 70.536C308.614 65.576 310.262 61.432 313.558 58.104C316.854 54.744 321.03 53.064 326.086 53.064C329.126 53.064 331.926 53.784 334.486 55.224C337.078 56.632 339.094 58.552 340.534 60.984L334.822 64.296C333.99 62.792 332.806 61.624 331.27 60.792C329.734 59.928 328.006 59.496 326.086 59.496C322.822 59.496 320.182 60.52 318.166 62.568C316.182 64.616 315.19 67.272 315.19 70.536C315.19 73.768 316.182 76.408 318.166 78.456C320.182 80.504 322.822 81.528 326.086 81.528C328.006 81.528 329.734 81.112 331.27 80.28C332.838 79.416 334.022 78.248 334.822 76.776L340.534 80.088C339.094 82.52 337.094 84.456 334.534 85.896C331.974 87.304 329.158 88.008 326.086 88.008Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M298.945 67.464C299.521 65.928 300.465 64.776 301.777 64.008C303.121 63.24 304.609 62.856 306.241 62.856V69.768C304.353 69.544 302.657 69.928 301.153 70.92C299.681 71.912 298.945 73.56 298.945 75.864V87.336H292.753V63.336H298.945V67.464Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M270.094 77.88C270.926 80.888 273.182 82.392 276.862 82.392C279.23 82.392 281.022 81.592 282.238 79.992L287.23 82.872C284.862 86.296 281.374 88.008 276.766 88.008C272.798 88.008 269.614 86.808 267.214 84.408C264.814 82.008 263.614 78.984 263.614 75.336C263.614 71.72 264.798 68.712 267.166 66.312C269.534 63.88 272.574 62.664 276.286 62.664C279.806 62.664 282.702 63.88 284.974 66.312C287.278 68.744 288.43 71.752 288.43 75.336C288.43 76.136 288.35 76.984 288.19 77.88H270.094ZM269.998 73.08H282.238C281.886 71.448 281.15 70.232 280.03 69.432C278.942 68.632 277.694 68.232 276.286 68.232C274.622 68.232 273.246 68.664 272.158 69.528C271.07 70.36 270.35 71.544 269.998 73.08Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M250.503 62.664C253.127 62.664 255.287 63.544 256.983 65.304C258.711 67.064 259.575 69.496 259.575 72.6V87.336H253.383V73.368C253.383 71.768 252.951 70.552 252.087 69.72C251.223 68.856 250.071 68.424 248.631 68.424C247.031 68.424 245.751 68.92 244.791 69.912C243.831 70.904 243.351 72.392 243.351 74.376V87.336H237.159V53.736H243.351V66.024C244.855 63.784 247.239 62.664 250.503 62.664Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M221.08 62.664C224.312 62.664 227.064 63.896 229.336 66.36C231.64 68.792 232.792 71.784 232.792 75.336C232.792 78.888 231.64 81.896 229.336 84.36C227.064 86.792 224.312 88.008 221.08 88.008C217.72 88.008 215.128 86.84 213.304 84.504V96.936H207.112V63.336H213.304V66.168C215.128 63.832 217.72 62.664 221.08 62.664ZM215.176 80.232C216.424 81.48 218.008 82.104 219.928 82.104C221.848 82.104 223.432 81.48 224.68 80.232C225.96 78.952 226.6 77.32 226.6 75.336C226.6 73.352 225.96 71.736 224.68 70.488C223.432 69.208 221.848 68.568 219.928 68.568C218.008 68.568 216.424 69.208 215.176 70.488C213.928 71.736 213.304 73.352 213.304 75.336C213.304 77.32 213.928 78.952 215.176 80.232Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M199.06 84.36C196.596 86.792 193.588 88.008 190.036 88.008C186.484 88.008 183.476 86.792 181.012 84.36C178.58 81.896 177.364 78.888 177.364 75.336C177.364 71.784 178.58 68.792 181.012 66.36C183.476 63.896 186.484 62.664 190.036 62.664C193.588 62.664 196.596 63.896 199.06 66.36C201.524 68.792 202.756 71.784 202.756 75.336C202.756 78.888 201.524 81.896 199.06 84.36ZM185.38 80.088C186.628 81.336 188.18 81.96 190.036 81.96C191.892 81.96 193.444 81.336 194.692 80.088C195.94 78.84 196.564 77.256 196.564 75.336C196.564 73.416 195.94 71.832 194.692 70.584C193.444 69.336 191.892 68.712 190.036 68.712C188.18 68.712 186.628 69.336 185.38 70.584C184.164 71.832 183.556 73.416 183.556 75.336C183.556 77.256 184.164 78.84 185.38 80.088Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M174.189 69.288V71.88C174.189 76.68 172.653 80.568 169.581 83.544C166.509 86.52 162.541 88.008 157.677 88.008C152.493 88.008 148.189 86.328 144.765 82.968C141.373 79.576 139.677 75.448 139.677 70.584C139.677 65.688 141.357 61.544 144.717 58.152C148.109 54.76 152.301 53.064 157.293 53.064C160.429 53.064 163.293 53.784 165.885 55.224C168.477 56.632 170.493 58.52 171.933 60.888L166.269 64.152C165.469 62.776 164.253 61.656 162.621 60.792C161.021 59.928 159.229 59.496 157.245 59.496C154.045 59.496 151.405 60.552 149.325 62.664C147.277 64.744 146.253 67.384 146.253 70.584C146.253 73.752 147.293 76.376 149.373 78.456C151.485 80.504 154.269 81.528 157.725 81.528C160.285 81.528 162.397 80.968 164.061 79.848C165.757 78.696 166.909 77.128 167.517 75.144H157.341V69.288H174.189Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.337c7b5beae6649c4c136df0ba41eb40.svg";
export { ForwardRef as ReactComponent };